// Digest: cf944f41878533b01060f3021c559a1f83dddf7f
/* eslint-disable */
/* eslint-disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export interface _Types {
  HomepageIndexProps: ServerTemplatesHomepageIndex;
  StockTrackerBarcodeSheetProps: StockTrackerTemplatesStockTrackerBarcodeSheet;
  StockTrackerBarcodeSheetsHistoryProps: StockTrackerTemplatesStockTrackerBarcodeSheetsHistory;
  StocktrackerStoreManagerNamesProps: StockTrackerTemplatesStocktrackerStoreManagerNames;
  StockTrackerScannerProps: StockTrackerTemplatesStockTrackerScanner;
  StockTrackerScanHistoryProps: StockTrackerTemplatesStockTrackerScanHistory;
  IProductLocatorProductProps: ProductLocatorViewsInterfacesResponseIProductLocatorProduct;
  MatchingProductsProps: ProductLocatorViewsInterfacesResponseMatchingProducts;
  IHomeLocationUpdateProps: ProductLocatorViewsInterfacesResponseIHomeLocationUpdate;
  IScanAuditCreationProps: ProductLocatorViewsInterfacesResponseIScanAuditCreation;
  IPlanogramsByStoreProps: ProductLocatorViewsInterfacesResponseIPlanogramsByStore;
  IProductLocationsProps: ProductLocatorViewsInterfacesResponseIProductLocations;
  ISuccessProps: ProductLocatorViewsInterfacesResponseISuccess;
  ProductLocatorIndexProps: ProductLocatorViewsTemplatesProductLocatorIndex;
  ProductLocatorAddNewProductsProps: ProductLocatorViewsTemplatesProductLocatorAddNewProducts;
  ProductLocatorManagePlanogramsProps: ProductLocatorViewsTemplatesProductLocatorManagePlanograms;
  ProductLocatorScanAuditProps: ProductLocatorViewsTemplatesProductLocatorScanAudit;
  QtLoginSessionRefetchProps: SurveyWorkerQtraxViewsInterfacesQtLoginSessionRefetch;
  QtViewRepDetailProps: SurveyWorkerQtraxViewsInterfacesQtViewRepDetail;
  TPaginationDataProps: SurveyWorkerQtraxUtilTypedefsTPaginationData;
  QtIndexProps: SurveyWorkerQtraxViewsTemplatesQtIndex;
  QtAdminProps: SurveyWorkerQtraxViewsTemplatesQtAdmin;
  QtRepSessionDetailsProps: SurveyWorkerQtraxViewsTemplatesQtRepSessionDetails;
  QtScheduleViewProps: SurveyWorkerQtraxViewsTemplatesQtScheduleView;
  QtTerritoryViewerProps: SurveyWorkerQtraxViewsTemplatesQtTerritoryViewer;
  QtUpdateScheduleProps: SurveyWorkerQtraxViewsTemplatesQtUpdateSchedule;
  QtAutofillLogsProps: SurveyWorkerQtraxViewsTemplatesQtAutofillLogs;
  globals: {
    Widget: DjangoFormsWidgetsTextarea | DjangoFormsWidgetsSelect | DjangoFormsWidgetsCheckboxInput;
    models: {};
  };
  Context: ReactivatedSerializationContextProcessorsBaseContext &
    ServerContextProcessorsTContextProvider &
    ReactivatedSerializationContextProcessorsMessagesProcessor &
    ReactivatedSerializationContextProcessorsCSRFProcessor &
    ReactivatedSerializationContextProcessorsRequestProcessor &
    ReactivatedSerializationContextProcessorsStaticProcessor;
}
export interface ServerTemplatesHomepageIndex {}
export interface StockTrackerTemplatesStockTrackerBarcodeSheet {
  barcodeSheet: StockTrackerTypesBarcodeSheetInterface;
  total_products: number;
  sheetTypeInfo: StockTrackerTypesSheetTypeDescriptionInterface;
  possibleSheetTypesInfo: StockTrackerTypesSheetTypeDescriptionInterface[];
}
export interface StockTrackerTypesBarcodeSheetInterface {
  barcode_sheet_id: number;
  store_name: string;
  parent_company: StockTrackerTypesParentCompanyInterface;
  product_additions: StockTrackerTypesProductAdditionInterface[];
}
export interface StockTrackerTypesParentCompanyInterface {
  short_name: string;
  expanded_name: string;
  third_party_logo_url: string;
}
export interface StockTrackerTypesProductAdditionInterface {
  id: number;
  product: StockTrackerTypesProductInterface;
  is_carried: boolean;
  is_new: boolean;
  date_ordered: string | null;
}
export interface StockTrackerTypesProductInterface {
  upc: string;
  name: string;
  upc_sections: string[];
  item_image_url: string;
  barcode_b64: string;
}
export interface StockTrackerTypesSheetTypeDescriptionInterface {
  sheetType: "all-products" | "out-of-dist" | "in-dist";
  sheetTypeVerbose: "All Products" | "Out Of Distribution" | "In Distribution";
}
export interface StockTrackerTemplatesStockTrackerBarcodeSheetsHistory {
  current_field_rep_id: number | null;
  field_representatives: FieldRepresentativeA025A185D5[];
  recent_barcode_sheets: BarcodeSheet_98425648E4[];
}
export interface FieldRepresentativeA025A185D5 {
  pk: number;
  name: string;
}
export interface BarcodeSheet_98425648E4 {
  pk: number;
  parent_company: {
    short_name: string | null;
    expanded_name: string | null;
  } | null;
  work_cycle: {
    start_date: string;
  } | null;
  store: {
    name: string;
  };
  datetime_created: string;
  product_additions: {
    pk: number;
  }[];
}
export interface StockTrackerTemplatesStocktrackerStoreManagerNames {
  field_reps: FieldRepresentative_3Ba5E2A106[];
}
export interface FieldRepresentative_3Ba5E2A106 {
  pk: number;
  name: string;
  stores: {
    pk: number;
    name: string;
    contacts: {
      pk: number;
      first_name: string | null;
      last_name: string | null;
    }[];
  }[];
}
export interface StockTrackerTemplatesStockTrackerScanner {
  field_reps: FieldRepresentative_93805Fc19C[];
}
export interface FieldRepresentative_93805Fc19C {
  pk: number;
  name: string;
  stores: {
    pk: number;
    name: string;
  }[];
}
export interface StockTrackerTemplatesStockTrackerScanHistory {
  field_reps: FieldRepresentative_93805Fc19C[];
}
export interface ProductLocatorViewsInterfacesResponseIProductLocatorProduct {
  product: Product_8C1496Dacb;
}
export interface Product_8C1496Dacb {
  pk: number;
  upc: string;
  name: string;
  date_created: string;
}
export interface ProductLocatorViewsInterfacesResponseMatchingProducts {
  products: Product_7B1A656Cf9[];
}
export interface Product_7B1A656Cf9 {
  pk: number;
  name: string;
  home_locations: {
    pk: number;
    name: string;
    planogram: {
      pk: number;
      name: string;
      plano_type_info: ProductLocatorModelsPlanogramTPlanoType;
    };
    display_name: string;
  }[];
}
export interface ProductLocatorModelsPlanogramTPlanoType {
  value: "inline" | "seasonal" | "other";
  label: string;
}
export interface ProductLocatorViewsInterfacesResponseIHomeLocationUpdate {
  home_location: HomeLocationE54D0Dea2A;
}
export interface HomeLocationE54D0Dea2A {
  pk: number;
  name: string;
  planogram: {
    pk: number;
    name: string;
    date_start: string;
    date_end: string | null;
    plano_type_info: ProductLocatorModelsPlanogramTPlanoType1;
  };
}
export interface ProductLocatorModelsPlanogramTPlanoType1 {
  value: "inline" | "seasonal" | "other";
  label: string;
}
export interface ProductLocatorViewsInterfacesResponseIScanAuditCreation {
  scan_audit: ProductScanAuditA55B39A1Bf;
}
export interface ProductScanAuditA55B39A1Bf {
  pk: number;
  product_type: string | null;
  datetime_created: string;
}
export interface ProductLocatorViewsInterfacesResponseIPlanogramsByStore {
  planograms: PlanogramE5Ec69B896[];
}
export interface PlanogramE5Ec69B896 {
  pk: number;
  name: string;
  date_start: string;
  date_end: string | null;
  plano_type_info: ProductLocatorModelsPlanogramTPlanoType2;
}
export interface ProductLocatorModelsPlanogramTPlanoType2 {
  value: "inline" | "seasonal" | "other";
  label: string;
}
export interface ProductLocatorViewsInterfacesResponseIProductLocations {
  product: Product_9A7F2C47Ce;
}
export interface Product_9A7F2C47Ce {
  pk: number;
  upc: string;
  name: string;
  date_created: string;
  home_locations: {
    pk: number;
    name: string;
    planogram: {
      pk: number;
      name: string;
      date_start: string;
      date_end: string | null;
      plano_type_info: ProductLocatorModelsPlanogramTPlanoType3;
    };
  }[];
}
export interface ProductLocatorModelsPlanogramTPlanoType3 {
  value: "inline" | "seasonal" | "other";
  label: string;
}
export interface ProductLocatorViewsInterfacesResponseISuccess {
  success: boolean;
}
export interface ProductLocatorViewsTemplatesProductLocatorIndex {
  stores: StoreD7Ddec6B39[];
  planograms: Planogram_0344C0Aff5[];
}
export interface StoreD7Ddec6B39 {
  pk: number;
  name: string;
}
export interface Planogram_0344C0Aff5 {
  pk: number;
  name: string;
  date_start: string;
  date_end: string | null;
  store: {
    pk: number;
  } | null;
}
export interface ProductLocatorViewsTemplatesProductLocatorAddNewProducts {
  form: ProductLocatorForms;
  stores: StoreD7Ddec6B39[];
}
export interface ProductLocatorForms {
  name: "product_locator.forms.PlanogramForm";
  errors: {
    planogram_text_dump?: string[];
    planogram_pk?: string[];
    is_reset_planogram?: string[];
  } | null;
  fields: {
    planogram_text_dump: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsTextarea;
    } & {};
    planogram_pk: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsSelect;
    } & {};
    is_reset_planogram: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsCheckboxInput;
    } & {};
  };
  prefix: string;
  iterator: ("planogram_text_dump" | "planogram_pk" | "is_reset_planogram")[];
  hidden_fields?: ("planogram_text_dump" | "planogram_pk" | "is_reset_planogram")[];
}
export interface ReactivatedSerializationFieldType {
  name: string;
  label: string;
  help_text: string | null;
}
export interface DjangoFormsWidgetsTextarea {
  template_name: "django/forms/widgets/textarea.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedSerializationWidgetsTextareaAttrs;
  tag: "django.forms.widgets.Textarea";
}
export interface ReactivatedSerializationWidgetsTextareaAttrs {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  cols: string;
  rows: string;
}
export interface DjangoFormsWidgetsSelect {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedSerializationWidgetsBaseWidgetAttrs;
  optgroups: [null, [ReactivatedSerializationWidgetsOptgroupMember], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedSerializationWidgetsBaseWidgetAttrs {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedSerializationWidgetsOptgroupMember {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsCheckboxInput {
  template_name: "django/forms/widgets/checkbox.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: boolean;
  attrs: ReactivatedSerializationWidgetsCheckAttrs;
  type: "checkbox";
  tag: "django.forms.widgets.CheckboxInput";
}
export interface ReactivatedSerializationWidgetsCheckAttrs {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  checked?: boolean;
}
export interface ProductLocatorViewsTemplatesProductLocatorManagePlanograms {
  stores: StoreD7Ddec6B39[];
  plano_type_choices: ProductLocatorModelsPlanogramTPlanoType4[];
  default_plano_name: string;
}
export interface ProductLocatorModelsPlanogramTPlanoType4 {
  value: "inline" | "seasonal" | "other";
  label: string;
}
export interface ProductLocatorViewsTemplatesProductLocatorScanAudit {
  previous_audits: ProductScanAuditDdbd2936Dd[];
}
export interface ProductScanAuditDdbd2936Dd {
  pk: number;
  product_type: string | null;
  datetime_created: string;
  products_in_stock: {
    upc: string;
  }[];
}
export interface SurveyWorkerQtraxViewsInterfacesQtLoginSessionRefetch {
  message: string;
}
export interface SurveyWorkerQtraxViewsInterfacesQtViewRepDetail {
  rep_sync_data: QtSyncData_2A44669617;
}
export interface QtSyncData_2A44669617 {
  id: number;
  rep_detail: {
    username: string;
  };
  schedule: SurveyWorkerQtraxWebsiteTypedefsTScheduleData | null;
  datetime_modified: string;
}
export interface SurveyWorkerQtraxWebsiteTypedefsTScheduleData {
  ScheduledDates: string[];
  ServiceOrders: SurveyWorkerQtraxWebsiteTypedefsTServiceOrder[];
  AllowSchedulingDates: string[];
  UnscheduledDate: string;
  UnassignableSOs: boolean;
  UnassignModeOn: boolean;
  AnyReasonSelected: boolean;
  ReasonSelected: number;
  ReasonSelectedIdx: number;
  UnassignReasons: string[];
  TimesheetInfo: SurveyWorkerQtraxWebsiteTypedefsTTimesheetInfo;
  Clients: string[];
}
export interface SurveyWorkerQtraxWebsiteTypedefsTServiceOrder {
  JobId: number;
  ServiceOrderDescription: string;
  NoVisitNecessary: boolean;
  DateScheduleRangeStart: string;
  DateScheduleRangeEnd: string;
  DateScheduled: string;
  EstimatedTime: number;
  RepId: number;
  RequiresTimeScheduling: boolean;
  NeedsTeamLeaderWarning: boolean;
  WaitForTeamLeaderToSchedule: boolean;
  TimeRemaingThisWeek: number;
  Distance: number;
  CanPrintInstructions: boolean;
  IsPastDue: boolean;
  DateScheduleRangeStartOriginal: string;
  DateScheduleRangeEndOriginal: string;
  TimeSchedulingRequired: boolean;
  TSDE: boolean;
  CanUnschedule: boolean;
  CheckInDate: string | null;
  JobClient: string;
  IsTLTM: boolean;
  TeamLeader: string | null;
  TeamMembers: string[] | null;
  VoltCheckInRequired: boolean;
  Priority: number;
  RepUnassignable: boolean;
  Address: SurveyWorkerQtraxWebsiteTypedefsAddress;
  ServiceOrderId: number;
}
export interface SurveyWorkerQtraxWebsiteTypedefsAddress {
  SiteId: number;
  StoreName: string;
  StoreNumber: string;
  StreetAddress: string;
  City: string;
  State: string;
  PostalCode: string;
  Latitude: number;
  Longitude: number;
  Phone: string | null;
  IsPhysicalVisit: boolean;
  IncludeInMileage: boolean;
  MapLink: string;
  StoreNumberSortable: string;
  IsAtPrsHQ: boolean;
  IsDone: boolean | null;
}
export interface SurveyWorkerQtraxWebsiteTypedefsTTimesheetInfo {
  FirstOpenDate: string;
  CanCloseMultiple: boolean;
  MinCloseableIdx: number;
  MaxCloseableIdx: number;
  ShowPayDates: boolean;
  PayPeriods: SurveyWorkerQtraxWebsiteTypedefsOverDuePayPeriodOrPayPeriod[];
  OverDuePayPeriod: SurveyWorkerQtraxWebsiteTypedefsOverDuePayPeriodOrPayPeriod;
  Timesheets: string[] | null;
}
export interface SurveyWorkerQtraxWebsiteTypedefsOverDuePayPeriodOrPayPeriod {
  BeginDate: string;
  DueDate: string;
  EndDate: string;
  PayDate: string;
  WeekNumber: number;
}
export interface SurveyWorkerQtraxUtilTypedefsTPaginationData {
  current_page: number;
  total_pages: number;
  has_previous: boolean;
  has_next: boolean;
  previous_page_number: number;
  next_page_number: number;
}
export interface SurveyWorkerQtraxViewsTemplatesQtIndex {}
export interface SurveyWorkerQtraxViewsTemplatesQtAdmin {
  reps: QtRepDetail_0F8955Dd82[];
}
export interface QtRepDetail_0F8955Dd82 {
  id: number;
  username: string;
}
export interface SurveyWorkerQtraxViewsTemplatesQtRepSessionDetails {
  rep_session_details: QtLoginSessionC9Cbbe4Bd0[];
}
export interface QtLoginSessionC9Cbbe4Bd0 {
  id: number;
  rep_detail: {
    username: string;
  };
  logged_in_datetime: string | null;
  session_data: ServerUtilsTypedefsTSessionData | null;
}
export interface ServerUtilsTypedefsTSessionData {
  cookies: {
    [k: string]: string;
  };
  headers: {
    [k: string]: string;
  };
}
export interface SurveyWorkerQtraxViewsTemplatesQtScheduleView {
  rep_details: QtRepDetail_0F8955Dd82[];
}
export interface SurveyWorkerQtraxViewsTemplatesQtTerritoryViewer {
  rep_sync_datalist: QtSyncData_2A44669617[];
}
export interface SurveyWorkerQtraxViewsTemplatesQtUpdateSchedule {
  reps: QtRepDetail_0F8955Dd82[];
}
export interface SurveyWorkerQtraxViewsTemplatesQtAutofillLogs {
  logs: QtAutofillLogE69B3D5305[];
  page_obj: ReactivatedTemplatesInterfaceLocalsAugmented;
}
export interface QtAutofillLogE69B3D5305 {
  id: number;
  service_order: {
    soid: number;
    store: {
      name: string;
    };
  };
  message_type: string;
  message: string;
  datetime_created: string;
}
export interface ReactivatedTemplatesInterfaceLocalsAugmented {
  current_page: number;
  total_pages: number;
  has_previous: boolean;
  has_next: boolean;
  previous_page_number: number;
  next_page_number: number;
}
export interface ReactivatedSerializationContextProcessorsBaseContext {
  template_name: string;
}
export interface ServerContextProcessorsTContextProvider {
  user: ServerContextProcessorsUserInfo;
  global_settings: GlobalSettings_721778Bb16 | null;
}
export interface ServerContextProcessorsUserInfo {
  name: string;
  is_superuser: boolean;
  is_authenticated: boolean;
}
export interface GlobalSettings_721778Bb16 {
  is_survey_launcher_enabled: boolean;
}
export interface ReactivatedSerializationContextProcessorsMessagesProcessor {
  messages: ReactivatedSerializationContextProcessorsMessage[];
}
export interface ReactivatedSerializationContextProcessorsMessage {
  level_tag: "info" | "success" | "error" | "warning" | "debug";
  message: string;
  level: number;
  from_server: boolean;
}
export interface ReactivatedSerializationContextProcessorsCSRFProcessor {
  csrf_token: string;
}
export interface ReactivatedSerializationContextProcessorsRequestProcessor {
  request: ReactivatedSerializationContextProcessorsRequest;
}
export interface ReactivatedSerializationContextProcessorsRequest {
  path: string;
  url: string;
  csp_nonce: string | null;
}
export interface ReactivatedSerializationContextProcessorsStaticProcessor {
  STATIC_URL: string;
}
const urls = {"admin:index":{"route":"/admin/","args":{}},"admin:login":{"route":"/admin/login/","args":{}},"admin:logout":{"route":"/admin/logout/","args":{}},"admin:password_change":{"route":"/admin/password_change/","args":{}},"admin:password_change_done":{"route":"/admin/password_change/done/","args":{}},"admin:autocomplete":{"route":"/admin/autocomplete/","args":{}},"admin:jsi18n":{"route":"/admin/jsi18n/","args":{}},"admin:view_on_site":{"route":"/admin/r/<int:content_type_id>/<path:object_id>/","args":{"content_type_id":"number","object_id":"string"}},"admin:auth_group_changelist":{"route":"/admin/auth/group/","args":{}},"admin:auth_group_add":{"route":"/admin/auth/group/add/","args":{}},"admin:auth_group_history":{"route":"/admin/auth/group/<path:object_id>/history/","args":{"object_id":"string"}},"admin:auth_group_delete":{"route":"/admin/auth/group/<path:object_id>/delete/","args":{"object_id":"string"}},"admin:auth_group_change":{"route":"/admin/auth/group/<path:object_id>/change/","args":{"object_id":"string"}},"admin/auth/group/<path:object_id>/":{"route":"/admin/auth/group/<path:object_id>/","args":{"object_id":"string"}},"admin:auth_user_password_change":{"route":"/admin/auth/user/<id>/password/","args":{"id":"string"}},"admin:auth_user_changelist":{"route":"/admin/auth/user/","args":{}},"admin:auth_user_add":{"route":"/admin/auth/user/add/","args":{}},"admin:auth_user_history":{"route":"/admin/auth/user/<path:object_id>/history/","args":{"object_id":"string"}},"admin:auth_user_delete":{"route":"/admin/auth/user/<path:object_id>/delete/","args":{"object_id":"string"}},"admin:auth_user_change":{"route":"/admin/auth/user/<path:object_id>/change/","args":{"object_id":"string"}},"admin/auth/user/<path:object_id>/":{"route":"/admin/auth/user/<path:object_id>/","args":{"object_id":"string"}},"admin:products_workcycle_changelist":{"route":"/admin/products/workcycle/","args":{}},"admin:products_workcycle_add":{"route":"/admin/products/workcycle/add/","args":{}},"admin:products_workcycle_history":{"route":"/admin/products/workcycle/<path:object_id>/history/","args":{"object_id":"string"}},"admin:products_workcycle_delete":{"route":"/admin/products/workcycle/<path:object_id>/delete/","args":{"object_id":"string"}},"admin:products_workcycle_change":{"route":"/admin/products/workcycle/<path:object_id>/change/","args":{"object_id":"string"}},"admin/products/workcycle/<path:object_id>/":{"route":"/admin/products/workcycle/<path:object_id>/","args":{"object_id":"string"}},"admin:products_fieldrepresentative_changelist":{"route":"/admin/products/fieldrepresentative/","args":{}},"admin:products_fieldrepresentative_add":{"route":"/admin/products/fieldrepresentative/add/","args":{}},"admin:products_fieldrepresentative_history":{"route":"/admin/products/fieldrepresentative/<path:object_id>/history/","args":{"object_id":"string"}},"admin:products_fieldrepresentative_delete":{"route":"/admin/products/fieldrepresentative/<path:object_id>/delete/","args":{"object_id":"string"}},"admin:products_fieldrepresentative_change":{"route":"/admin/products/fieldrepresentative/<path:object_id>/change/","args":{"object_id":"string"}},"admin/products/fieldrepresentative/<path:object_id>/":{"route":"/admin/products/fieldrepresentative/<path:object_id>/","args":{"object_id":"string"}},"admin:products_brandparentcompany_changelist":{"route":"/admin/products/brandparentcompany/","args":{}},"admin:products_brandparentcompany_add":{"route":"/admin/products/brandparentcompany/add/","args":{}},"admin:products_brandparentcompany_history":{"route":"/admin/products/brandparentcompany/<path:object_id>/history/","args":{"object_id":"string"}},"admin:products_brandparentcompany_delete":{"route":"/admin/products/brandparentcompany/<path:object_id>/delete/","args":{"object_id":"string"}},"admin:products_brandparentcompany_change":{"route":"/admin/products/brandparentcompany/<path:object_id>/change/","args":{"object_id":"string"}},"admin/products/brandparentcompany/<path:object_id>/":{"route":"/admin/products/brandparentcompany/<path:object_id>/","args":{"object_id":"string"}},"admin:products_product_changelist":{"route":"/admin/products/product/","args":{}},"admin:products_product_add":{"route":"/admin/products/product/add/","args":{}},"admin:products_product_history":{"route":"/admin/products/product/<path:object_id>/history/","args":{"object_id":"string"}},"admin:products_product_delete":{"route":"/admin/products/product/<path:object_id>/delete/","args":{"object_id":"string"}},"admin:products_product_change":{"route":"/admin/products/product/<path:object_id>/change/","args":{"object_id":"string"}},"admin/products/product/<path:object_id>/":{"route":"/admin/products/product/<path:object_id>/","args":{"object_id":"string"}},"admin:products_storeguid_changelist":{"route":"/admin/products/storeguid/","args":{}},"admin:products_storeguid_add":{"route":"/admin/products/storeguid/add/","args":{}},"admin:products_storeguid_history":{"route":"/admin/products/storeguid/<path:object_id>/history/","args":{"object_id":"string"}},"admin:products_storeguid_delete":{"route":"/admin/products/storeguid/<path:object_id>/delete/","args":{"object_id":"string"}},"admin:products_storeguid_change":{"route":"/admin/products/storeguid/<path:object_id>/change/","args":{"object_id":"string"}},"admin/products/storeguid/<path:object_id>/":{"route":"/admin/products/storeguid/<path:object_id>/","args":{"object_id":"string"}},"admin:products_store_changelist":{"route":"/admin/products/store/","args":{}},"admin:products_store_add":{"route":"/admin/products/store/add/","args":{}},"admin:products_store_history":{"route":"/admin/products/store/<path:object_id>/history/","args":{"object_id":"string"}},"admin:products_store_delete":{"route":"/admin/products/store/<path:object_id>/delete/","args":{"object_id":"string"}},"admin:products_store_change":{"route":"/admin/products/store/<path:object_id>/change/","args":{"object_id":"string"}},"admin/products/store/<path:object_id>/":{"route":"/admin/products/store/<path:object_id>/","args":{"object_id":"string"}},"admin:products_productaddition_changelist":{"route":"/admin/products/productaddition/","args":{}},"admin:products_productaddition_add":{"route":"/admin/products/productaddition/add/","args":{}},"admin:products_productaddition_history":{"route":"/admin/products/productaddition/<path:object_id>/history/","args":{"object_id":"string"}},"admin:products_productaddition_delete":{"route":"/admin/products/productaddition/<path:object_id>/delete/","args":{"object_id":"string"}},"admin:products_productaddition_change":{"route":"/admin/products/productaddition/<path:object_id>/change/","args":{"object_id":"string"}},"admin/products/productaddition/<path:object_id>/":{"route":"/admin/products/productaddition/<path:object_id>/","args":{"object_id":"string"}},"admin:products_personnelcontact_changelist":{"route":"/admin/products/personnelcontact/","args":{}},"admin:products_personnelcontact_add":{"route":"/admin/products/personnelcontact/add/","args":{}},"admin:products_personnelcontact_history":{"route":"/admin/products/personnelcontact/<path:object_id>/history/","args":{"object_id":"string"}},"admin:products_personnelcontact_delete":{"route":"/admin/products/personnelcontact/<path:object_id>/delete/","args":{"object_id":"string"}},"admin:products_personnelcontact_change":{"route":"/admin/products/personnelcontact/<path:object_id>/change/","args":{"object_id":"string"}},"admin/products/personnelcontact/<path:object_id>/":{"route":"/admin/products/personnelcontact/<path:object_id>/","args":{"object_id":"string"}},"admin:products_barcodesheet_changelist":{"route":"/admin/products/barcodesheet/","args":{}},"admin:products_barcodesheet_add":{"route":"/admin/products/barcodesheet/add/","args":{}},"admin:products_barcodesheet_history":{"route":"/admin/products/barcodesheet/<path:object_id>/history/","args":{"object_id":"string"}},"admin:products_barcodesheet_delete":{"route":"/admin/products/barcodesheet/<path:object_id>/delete/","args":{"object_id":"string"}},"admin:products_barcodesheet_change":{"route":"/admin/products/barcodesheet/<path:object_id>/change/","args":{"object_id":"string"}},"admin/products/barcodesheet/<path:object_id>/":{"route":"/admin/products/barcodesheet/<path:object_id>/","args":{"object_id":"string"}},"admin:product_locator_planogram_changelist":{"route":"/admin/product_locator/planogram/","args":{}},"admin:product_locator_planogram_add":{"route":"/admin/product_locator/planogram/add/","args":{}},"admin:product_locator_planogram_history":{"route":"/admin/product_locator/planogram/<path:object_id>/history/","args":{"object_id":"string"}},"admin:product_locator_planogram_delete":{"route":"/admin/product_locator/planogram/<path:object_id>/delete/","args":{"object_id":"string"}},"admin:product_locator_planogram_change":{"route":"/admin/product_locator/planogram/<path:object_id>/change/","args":{"object_id":"string"}},"admin/product_locator/planogram/<path:object_id>/":{"route":"/admin/product_locator/planogram/<path:object_id>/","args":{"object_id":"string"}},"admin:product_locator_homelocation_changelist":{"route":"/admin/product_locator/homelocation/","args":{}},"admin:product_locator_homelocation_add":{"route":"/admin/product_locator/homelocation/add/","args":{}},"admin:product_locator_homelocation_history":{"route":"/admin/product_locator/homelocation/<path:object_id>/history/","args":{"object_id":"string"}},"admin:product_locator_homelocation_delete":{"route":"/admin/product_locator/homelocation/<path:object_id>/delete/","args":{"object_id":"string"}},"admin:product_locator_homelocation_change":{"route":"/admin/product_locator/homelocation/<path:object_id>/change/","args":{"object_id":"string"}},"admin/product_locator/homelocation/<path:object_id>/":{"route":"/admin/product_locator/homelocation/<path:object_id>/","args":{"object_id":"string"}},"admin:product_locator_product_changelist":{"route":"/admin/product_locator/product/","args":{}},"admin:product_locator_product_add":{"route":"/admin/product_locator/product/add/","args":{}},"admin:product_locator_product_history":{"route":"/admin/product_locator/product/<path:object_id>/history/","args":{"object_id":"string"}},"admin:product_locator_product_delete":{"route":"/admin/product_locator/product/<path:object_id>/delete/","args":{"object_id":"string"}},"admin:product_locator_product_change":{"route":"/admin/product_locator/product/<path:object_id>/change/","args":{"object_id":"string"}},"admin/product_locator/product/<path:object_id>/":{"route":"/admin/product_locator/product/<path:object_id>/","args":{"object_id":"string"}},"admin:product_locator_productscanaudit_changelist":{"route":"/admin/product_locator/productscanaudit/","args":{}},"admin:product_locator_productscanaudit_add":{"route":"/admin/product_locator/productscanaudit/add/","args":{}},"admin:product_locator_productscanaudit_history":{"route":"/admin/product_locator/productscanaudit/<path:object_id>/history/","args":{"object_id":"string"}},"admin:product_locator_productscanaudit_delete":{"route":"/admin/product_locator/productscanaudit/<path:object_id>/delete/","args":{"object_id":"string"}},"admin:product_locator_productscanaudit_change":{"route":"/admin/product_locator/productscanaudit/<path:object_id>/change/","args":{"object_id":"string"}},"admin/product_locator/productscanaudit/<path:object_id>/":{"route":"/admin/product_locator/productscanaudit/<path:object_id>/","args":{"object_id":"string"}},"admin:product_locator_store_changelist":{"route":"/admin/product_locator/store/","args":{}},"admin:product_locator_store_add":{"route":"/admin/product_locator/store/add/","args":{}},"admin:product_locator_store_history":{"route":"/admin/product_locator/store/<path:object_id>/history/","args":{"object_id":"string"}},"admin:product_locator_store_delete":{"route":"/admin/product_locator/store/<path:object_id>/delete/","args":{"object_id":"string"}},"admin:product_locator_store_change":{"route":"/admin/product_locator/store/<path:object_id>/change/","args":{"object_id":"string"}},"admin/product_locator/store/<path:object_id>/":{"route":"/admin/product_locator/store/<path:object_id>/","args":{"object_id":"string"}},"admin:survey_worker_qtrepdetail_changelist":{"route":"/admin/survey_worker/qtrepdetail/","args":{}},"admin:survey_worker_qtrepdetail_add":{"route":"/admin/survey_worker/qtrepdetail/add/","args":{}},"admin:survey_worker_qtrepdetail_history":{"route":"/admin/survey_worker/qtrepdetail/<path:object_id>/history/","args":{"object_id":"string"}},"admin:survey_worker_qtrepdetail_delete":{"route":"/admin/survey_worker/qtrepdetail/<path:object_id>/delete/","args":{"object_id":"string"}},"admin:survey_worker_qtrepdetail_change":{"route":"/admin/survey_worker/qtrepdetail/<path:object_id>/change/","args":{"object_id":"string"}},"admin/survey_worker/qtrepdetail/<path:object_id>/":{"route":"/admin/survey_worker/qtrepdetail/<path:object_id>/","args":{"object_id":"string"}},"admin:survey_worker_qtloginsession_changelist":{"route":"/admin/survey_worker/qtloginsession/","args":{}},"admin:survey_worker_qtloginsession_add":{"route":"/admin/survey_worker/qtloginsession/add/","args":{}},"admin:survey_worker_qtloginsession_history":{"route":"/admin/survey_worker/qtloginsession/<path:object_id>/history/","args":{"object_id":"string"}},"admin:survey_worker_qtloginsession_delete":{"route":"/admin/survey_worker/qtloginsession/<path:object_id>/delete/","args":{"object_id":"string"}},"admin:survey_worker_qtloginsession_change":{"route":"/admin/survey_worker/qtloginsession/<path:object_id>/change/","args":{"object_id":"string"}},"admin/survey_worker/qtloginsession/<path:object_id>/":{"route":"/admin/survey_worker/qtloginsession/<path:object_id>/","args":{"object_id":"string"}},"admin:survey_worker_qtjob_changelist":{"route":"/admin/survey_worker/qtjob/","args":{}},"admin:survey_worker_qtjob_add":{"route":"/admin/survey_worker/qtjob/add/","args":{}},"admin:survey_worker_qtjob_history":{"route":"/admin/survey_worker/qtjob/<path:object_id>/history/","args":{"object_id":"string"}},"admin:survey_worker_qtjob_delete":{"route":"/admin/survey_worker/qtjob/<path:object_id>/delete/","args":{"object_id":"string"}},"admin:survey_worker_qtjob_change":{"route":"/admin/survey_worker/qtjob/<path:object_id>/change/","args":{"object_id":"string"}},"admin/survey_worker/qtjob/<path:object_id>/":{"route":"/admin/survey_worker/qtjob/<path:object_id>/","args":{"object_id":"string"}},"admin:survey_worker_qtsyncdata_changelist":{"route":"/admin/survey_worker/qtsyncdata/","args":{}},"admin:survey_worker_qtsyncdata_add":{"route":"/admin/survey_worker/qtsyncdata/add/","args":{}},"admin:survey_worker_qtsyncdata_history":{"route":"/admin/survey_worker/qtsyncdata/<path:object_id>/history/","args":{"object_id":"string"}},"admin:survey_worker_qtsyncdata_delete":{"route":"/admin/survey_worker/qtsyncdata/<path:object_id>/delete/","args":{"object_id":"string"}},"admin:survey_worker_qtsyncdata_change":{"route":"/admin/survey_worker/qtsyncdata/<path:object_id>/change/","args":{"object_id":"string"}},"admin/survey_worker/qtsyncdata/<path:object_id>/":{"route":"/admin/survey_worker/qtsyncdata/<path:object_id>/","args":{"object_id":"string"}},"admin:survey_worker_qtserviceorder_changelist":{"route":"/admin/survey_worker/qtserviceorder/","args":{}},"admin:survey_worker_qtserviceorder_add":{"route":"/admin/survey_worker/qtserviceorder/add/","args":{}},"admin:survey_worker_qtserviceorder_history":{"route":"/admin/survey_worker/qtserviceorder/<path:object_id>/history/","args":{"object_id":"string"}},"admin:survey_worker_qtserviceorder_delete":{"route":"/admin/survey_worker/qtserviceorder/<path:object_id>/delete/","args":{"object_id":"string"}},"admin:survey_worker_qtserviceorder_change":{"route":"/admin/survey_worker/qtserviceorder/<path:object_id>/change/","args":{"object_id":"string"}},"admin/survey_worker/qtserviceorder/<path:object_id>/":{"route":"/admin/survey_worker/qtserviceorder/<path:object_id>/","args":{"object_id":"string"}},"admin:survey_worker_globalsettings_changelist":{"route":"/admin/survey_worker/globalsettings/","args":{}},"admin:survey_worker_globalsettings_add":{"route":"/admin/survey_worker/globalsettings/add/","args":{}},"admin:survey_worker_globalsettings_history":{"route":"/admin/survey_worker/globalsettings/<path:object_id>/history/","args":{"object_id":"string"}},"admin:survey_worker_globalsettings_delete":{"route":"/admin/survey_worker/globalsettings/<path:object_id>/delete/","args":{"object_id":"string"}},"admin:survey_worker_globalsettings_change":{"route":"/admin/survey_worker/globalsettings/<path:object_id>/change/","args":{"object_id":"string"}},"admin/survey_worker/globalsettings/<path:object_id>/":{"route":"/admin/survey_worker/globalsettings/<path:object_id>/","args":{"object_id":"string"}},"admin:authtoken_tokenproxy_changelist":{"route":"/admin/authtoken/tokenproxy/","args":{}},"admin:authtoken_tokenproxy_add":{"route":"/admin/authtoken/tokenproxy/add/","args":{}},"admin:authtoken_tokenproxy_history":{"route":"/admin/authtoken/tokenproxy/<path:object_id>/history/","args":{"object_id":"string"}},"admin:authtoken_tokenproxy_delete":{"route":"/admin/authtoken/tokenproxy/<path:object_id>/delete/","args":{"object_id":"string"}},"admin:authtoken_tokenproxy_change":{"route":"/admin/authtoken/tokenproxy/<path:object_id>/change/","args":{"object_id":"string"}},"admin/authtoken/tokenproxy/<path:object_id>/":{"route":"/admin/authtoken/tokenproxy/<path:object_id>/","args":{"object_id":"string"}},"root:index":{"route":"/","args":{}},"api:validate_api_token":{"route":"/api/validate_api_token/","args":{}},"api:get_store_product_additions":{"route":"/api/get_store_product_additions/","args":{}},"api:get_field_reps":{"route":"/api/get_field_reps/","args":{}},"api:update_store_field_rep":{"route":"/api/update_store_field_rep/","args":{}},"api:update_store_personnel":{"route":"/api/update_store_personnel/","args":{}},"api:update_cmk_html_src":{"route":"/api/update_cmk_html_src/","args":{}},"api:get_service_order_info":{"route":"/api/get_service_order_info/<int:soid>/","args":{"soid":"number"}},"stock_tracker:scanner":{"route":"/logger/scanner/","args":{}},"stock_tracker:login_view":{"route":"/logger/login/","args":{}},"stock_tracker:logout_view":{"route":"/logger/logout/","args":{}},"stock_tracker:add_new_stores":{"route":"/logger/add_new_stores/","args":{}},"stock_tracker:scan_history":{"route":"/logger/scan_history/","args":{}},"stock_tracker:uncarry_product_addition":{"route":"/logger/uncarry_product_addition/<int:product_addition_pk>/","args":{"product_addition_pk":"number"}},"stock_tracker:import_json_data_files":{"route":"/logger/import_json_data_files/","args":{}},"stock_tracker:barcode_sheet_history":{"route":"/logger/barcode_sheet_history/","args":{}},"stock_tracker:barcode_sheet_history_repid":{"route":"/logger/barcode_sheet_history/<int:field_representative_id>/","args":{"field_representative_id":"number"}},"stock_tracker:get_barcode_sheet":{"route":"/logger/barcode_sheet/<int:barcode_sheet_id>/","args":{"barcode_sheet_id":"number"}},"stock_tracker:get_manager_names":{"route":"/logger/store_manager_names/","args":{}},"stock_tracker:set_carried_product_additions":{"route":"/logger/set_carried_product_additions/","args":{}},"stock_tracker:set_product_distribution_order_status":{"route":"/logger/set_product_distribution_order_status/","args":{}},"stock_tracker:get_product_additions_by_store":{"route":"/logger/get_product_additions_by_store/","args":{}},"stock_tracker:uncarry_product_addition_by_id":{"route":"/logger/uncarry_product_addition_by_id/","args":{}},"stock_tracker:log_product_scan":{"route":"/logger/log_product_scan/","args":{}},"product_locator:index":{"route":"/product_locator/","args":{}},"product_locator:add_new_products":{"route":"/product_locator/add_new_products/","args":{}},"product_locator:manage_planograms":{"route":"/product_locator/manage_planograms/","args":{}},"product_locator:scan_audit":{"route":"/product_locator/scan_audit/","args":{}},"product_locator:get_product_location":{"route":"/product_locator/ajax/get_product_location/","args":{}},"product_locator:get_product_locations_by_name":{"route":"/product_locator/ajax/get_product_locations_by_name/<int:store_id>/<str:product_name>/","args":{"store_id":"number","product_name":"string"}},"product_locator:add_new_product_location":{"route":"/product_locator/ajax/add_new_product_location/","args":{}},"product_locator:add_upc_to_scan_audit":{"route":"/product_locator/ajax/add_upc_to_scan_audit/","args":{}},"product_locator:create_new_scan_audit":{"route":"/product_locator/ajax/create_new_scan_audit/","args":{}},"product_locator:get_planograms_by_store":{"route":"/product_locator/ajax/get_planograms_by_store/<int:store_id>/","args":{"store_id":"number"}},"product_locator:delete_planogram":{"route":"/product_locator/ajax/delete_planogram/<int:planogram_id>/","args":{"planogram_id":"number"}},"product_locator:get_planogram_locations":{"route":"/product_locator/api/get_planogram_locations/","args":{}},"product_locator:get_products_from_latest_scan_audit":{"route":"/product_locator/api/get_products_from_latest_scan_audit/","args":{}},"survey_worker:index":{"route":"/survey_worker/","args":{}},"survey_worker:qt_admin":{"route":"/survey_worker/admin/","args":{}},"survey_worker:qt_view_login_sessions":{"route":"/survey_worker/view_login_sessions/","args":{}},"survey_worker:qt_view_schedules":{"route":"/survey_worker/view_schedules/","args":{}},"survey_worker:qt_territory_viewer":{"route":"/survey_worker/qt_territory_viewer/","args":{}},"survey_worker:qt_update_schedule":{"route":"/survey_worker/update_schedule/","args":{}},"survey_worker:qt_view_autofill_logs":{"route":"/survey_worker/view_autofill_logs/","args":{}},"survey_worker:qt_force_fetch_login_session":{"route":"/survey_worker/force-fetch-login-session/<int:rep_id>/","args":{"rep_id":"number"}},"survey_worker:qt_view_rep_schedule":{"route":"/survey_worker/view_rep_schedule/<int:rep_id>/","args":{"rep_id":"number"}},"survey_worker:qt_log_autofill_message":{"route":"/survey_worker/api/log_autofill_message/","args":{}},"__reactivated_do_not_use":{"route":"__reactivated_do_not_use","args":{}},"__reactivated_do_not_use_args":{"route":"__reactivated_do_not_use_args","args":{"_":"string"}}};

export interface URLMap {
    admin_index: admin_index;
    admin_login: admin_login;
    admin_logout: admin_logout;
    admin_password_change: admin_password_change;
    admin_password_change_done: admin_password_change_done;
    admin_autocomplete: admin_autocomplete;
    admin_jsi18n: admin_jsi18n;
    admin_view_on_site: admin_view_on_site;
    admin_auth_group_changelist: admin_auth_group_changelist;
    admin_auth_group_add: admin_auth_group_add;
    admin_auth_group_history: admin_auth_group_history;
    admin_auth_group_delete: admin_auth_group_delete;
    admin_auth_group_change: admin_auth_group_change;
    admin_auth_group__path_object_id__: admin_auth_group__path_object_id__;
    admin_auth_user_password_change: admin_auth_user_password_change;
    admin_auth_user_changelist: admin_auth_user_changelist;
    admin_auth_user_add: admin_auth_user_add;
    admin_auth_user_history: admin_auth_user_history;
    admin_auth_user_delete: admin_auth_user_delete;
    admin_auth_user_change: admin_auth_user_change;
    admin_auth_user__path_object_id__: admin_auth_user__path_object_id__;
    admin_products_workcycle_changelist: admin_products_workcycle_changelist;
    admin_products_workcycle_add: admin_products_workcycle_add;
    admin_products_workcycle_history: admin_products_workcycle_history;
    admin_products_workcycle_delete: admin_products_workcycle_delete;
    admin_products_workcycle_change: admin_products_workcycle_change;
    admin_products_workcycle__path_object_id__: admin_products_workcycle__path_object_id__;
    admin_products_fieldrepresentative_changelist: admin_products_fieldrepresentative_changelist;
    admin_products_fieldrepresentative_add: admin_products_fieldrepresentative_add;
    admin_products_fieldrepresentative_history: admin_products_fieldrepresentative_history;
    admin_products_fieldrepresentative_delete: admin_products_fieldrepresentative_delete;
    admin_products_fieldrepresentative_change: admin_products_fieldrepresentative_change;
    admin_products_fieldrepresentative__path_object_id__: admin_products_fieldrepresentative__path_object_id__;
    admin_products_brandparentcompany_changelist: admin_products_brandparentcompany_changelist;
    admin_products_brandparentcompany_add: admin_products_brandparentcompany_add;
    admin_products_brandparentcompany_history: admin_products_brandparentcompany_history;
    admin_products_brandparentcompany_delete: admin_products_brandparentcompany_delete;
    admin_products_brandparentcompany_change: admin_products_brandparentcompany_change;
    admin_products_brandparentcompany__path_object_id__: admin_products_brandparentcompany__path_object_id__;
    admin_products_product_changelist: admin_products_product_changelist;
    admin_products_product_add: admin_products_product_add;
    admin_products_product_history: admin_products_product_history;
    admin_products_product_delete: admin_products_product_delete;
    admin_products_product_change: admin_products_product_change;
    admin_products_product__path_object_id__: admin_products_product__path_object_id__;
    admin_products_storeguid_changelist: admin_products_storeguid_changelist;
    admin_products_storeguid_add: admin_products_storeguid_add;
    admin_products_storeguid_history: admin_products_storeguid_history;
    admin_products_storeguid_delete: admin_products_storeguid_delete;
    admin_products_storeguid_change: admin_products_storeguid_change;
    admin_products_storeguid__path_object_id__: admin_products_storeguid__path_object_id__;
    admin_products_store_changelist: admin_products_store_changelist;
    admin_products_store_add: admin_products_store_add;
    admin_products_store_history: admin_products_store_history;
    admin_products_store_delete: admin_products_store_delete;
    admin_products_store_change: admin_products_store_change;
    admin_products_store__path_object_id__: admin_products_store__path_object_id__;
    admin_products_productaddition_changelist: admin_products_productaddition_changelist;
    admin_products_productaddition_add: admin_products_productaddition_add;
    admin_products_productaddition_history: admin_products_productaddition_history;
    admin_products_productaddition_delete: admin_products_productaddition_delete;
    admin_products_productaddition_change: admin_products_productaddition_change;
    admin_products_productaddition__path_object_id__: admin_products_productaddition__path_object_id__;
    admin_products_personnelcontact_changelist: admin_products_personnelcontact_changelist;
    admin_products_personnelcontact_add: admin_products_personnelcontact_add;
    admin_products_personnelcontact_history: admin_products_personnelcontact_history;
    admin_products_personnelcontact_delete: admin_products_personnelcontact_delete;
    admin_products_personnelcontact_change: admin_products_personnelcontact_change;
    admin_products_personnelcontact__path_object_id__: admin_products_personnelcontact__path_object_id__;
    admin_products_barcodesheet_changelist: admin_products_barcodesheet_changelist;
    admin_products_barcodesheet_add: admin_products_barcodesheet_add;
    admin_products_barcodesheet_history: admin_products_barcodesheet_history;
    admin_products_barcodesheet_delete: admin_products_barcodesheet_delete;
    admin_products_barcodesheet_change: admin_products_barcodesheet_change;
    admin_products_barcodesheet__path_object_id__: admin_products_barcodesheet__path_object_id__;
    admin_product_locator_planogram_changelist: admin_product_locator_planogram_changelist;
    admin_product_locator_planogram_add: admin_product_locator_planogram_add;
    admin_product_locator_planogram_history: admin_product_locator_planogram_history;
    admin_product_locator_planogram_delete: admin_product_locator_planogram_delete;
    admin_product_locator_planogram_change: admin_product_locator_planogram_change;
    admin_product_locator_planogram__path_object_id__: admin_product_locator_planogram__path_object_id__;
    admin_product_locator_homelocation_changelist: admin_product_locator_homelocation_changelist;
    admin_product_locator_homelocation_add: admin_product_locator_homelocation_add;
    admin_product_locator_homelocation_history: admin_product_locator_homelocation_history;
    admin_product_locator_homelocation_delete: admin_product_locator_homelocation_delete;
    admin_product_locator_homelocation_change: admin_product_locator_homelocation_change;
    admin_product_locator_homelocation__path_object_id__: admin_product_locator_homelocation__path_object_id__;
    admin_product_locator_product_changelist: admin_product_locator_product_changelist;
    admin_product_locator_product_add: admin_product_locator_product_add;
    admin_product_locator_product_history: admin_product_locator_product_history;
    admin_product_locator_product_delete: admin_product_locator_product_delete;
    admin_product_locator_product_change: admin_product_locator_product_change;
    admin_product_locator_product__path_object_id__: admin_product_locator_product__path_object_id__;
    admin_product_locator_productscanaudit_changelist: admin_product_locator_productscanaudit_changelist;
    admin_product_locator_productscanaudit_add: admin_product_locator_productscanaudit_add;
    admin_product_locator_productscanaudit_history: admin_product_locator_productscanaudit_history;
    admin_product_locator_productscanaudit_delete: admin_product_locator_productscanaudit_delete;
    admin_product_locator_productscanaudit_change: admin_product_locator_productscanaudit_change;
    admin_product_locator_productscanaudit__path_object_id__: admin_product_locator_productscanaudit__path_object_id__;
    admin_product_locator_store_changelist: admin_product_locator_store_changelist;
    admin_product_locator_store_add: admin_product_locator_store_add;
    admin_product_locator_store_history: admin_product_locator_store_history;
    admin_product_locator_store_delete: admin_product_locator_store_delete;
    admin_product_locator_store_change: admin_product_locator_store_change;
    admin_product_locator_store__path_object_id__: admin_product_locator_store__path_object_id__;
    admin_survey_worker_qtrepdetail_changelist: admin_survey_worker_qtrepdetail_changelist;
    admin_survey_worker_qtrepdetail_add: admin_survey_worker_qtrepdetail_add;
    admin_survey_worker_qtrepdetail_history: admin_survey_worker_qtrepdetail_history;
    admin_survey_worker_qtrepdetail_delete: admin_survey_worker_qtrepdetail_delete;
    admin_survey_worker_qtrepdetail_change: admin_survey_worker_qtrepdetail_change;
    admin_survey_worker_qtrepdetail__path_object_id__: admin_survey_worker_qtrepdetail__path_object_id__;
    admin_survey_worker_qtloginsession_changelist: admin_survey_worker_qtloginsession_changelist;
    admin_survey_worker_qtloginsession_add: admin_survey_worker_qtloginsession_add;
    admin_survey_worker_qtloginsession_history: admin_survey_worker_qtloginsession_history;
    admin_survey_worker_qtloginsession_delete: admin_survey_worker_qtloginsession_delete;
    admin_survey_worker_qtloginsession_change: admin_survey_worker_qtloginsession_change;
    admin_survey_worker_qtloginsession__path_object_id__: admin_survey_worker_qtloginsession__path_object_id__;
    admin_survey_worker_qtjob_changelist: admin_survey_worker_qtjob_changelist;
    admin_survey_worker_qtjob_add: admin_survey_worker_qtjob_add;
    admin_survey_worker_qtjob_history: admin_survey_worker_qtjob_history;
    admin_survey_worker_qtjob_delete: admin_survey_worker_qtjob_delete;
    admin_survey_worker_qtjob_change: admin_survey_worker_qtjob_change;
    admin_survey_worker_qtjob__path_object_id__: admin_survey_worker_qtjob__path_object_id__;
    admin_survey_worker_qtsyncdata_changelist: admin_survey_worker_qtsyncdata_changelist;
    admin_survey_worker_qtsyncdata_add: admin_survey_worker_qtsyncdata_add;
    admin_survey_worker_qtsyncdata_history: admin_survey_worker_qtsyncdata_history;
    admin_survey_worker_qtsyncdata_delete: admin_survey_worker_qtsyncdata_delete;
    admin_survey_worker_qtsyncdata_change: admin_survey_worker_qtsyncdata_change;
    admin_survey_worker_qtsyncdata__path_object_id__: admin_survey_worker_qtsyncdata__path_object_id__;
    admin_survey_worker_qtserviceorder_changelist: admin_survey_worker_qtserviceorder_changelist;
    admin_survey_worker_qtserviceorder_add: admin_survey_worker_qtserviceorder_add;
    admin_survey_worker_qtserviceorder_history: admin_survey_worker_qtserviceorder_history;
    admin_survey_worker_qtserviceorder_delete: admin_survey_worker_qtserviceorder_delete;
    admin_survey_worker_qtserviceorder_change: admin_survey_worker_qtserviceorder_change;
    admin_survey_worker_qtserviceorder__path_object_id__: admin_survey_worker_qtserviceorder__path_object_id__;
    admin_survey_worker_globalsettings_changelist: admin_survey_worker_globalsettings_changelist;
    admin_survey_worker_globalsettings_add: admin_survey_worker_globalsettings_add;
    admin_survey_worker_globalsettings_history: admin_survey_worker_globalsettings_history;
    admin_survey_worker_globalsettings_delete: admin_survey_worker_globalsettings_delete;
    admin_survey_worker_globalsettings_change: admin_survey_worker_globalsettings_change;
    admin_survey_worker_globalsettings__path_object_id__: admin_survey_worker_globalsettings__path_object_id__;
    admin_authtoken_tokenproxy_changelist: admin_authtoken_tokenproxy_changelist;
    admin_authtoken_tokenproxy_add: admin_authtoken_tokenproxy_add;
    admin_authtoken_tokenproxy_history: admin_authtoken_tokenproxy_history;
    admin_authtoken_tokenproxy_delete: admin_authtoken_tokenproxy_delete;
    admin_authtoken_tokenproxy_change: admin_authtoken_tokenproxy_change;
    admin_authtoken_tokenproxy__path_object_id__: admin_authtoken_tokenproxy__path_object_id__;
    root_index: root_index;
    api_validate_api_token: api_validate_api_token;
    api_get_store_product_additions: api_get_store_product_additions;
    api_get_field_reps: api_get_field_reps;
    api_update_store_field_rep: api_update_store_field_rep;
    api_update_store_personnel: api_update_store_personnel;
    api_update_cmk_html_src: api_update_cmk_html_src;
    api_get_service_order_info: api_get_service_order_info;
    stock_tracker_scanner: stock_tracker_scanner;
    stock_tracker_login_view: stock_tracker_login_view;
    stock_tracker_logout_view: stock_tracker_logout_view;
    stock_tracker_add_new_stores: stock_tracker_add_new_stores;
    stock_tracker_scan_history: stock_tracker_scan_history;
    stock_tracker_uncarry_product_addition: stock_tracker_uncarry_product_addition;
    stock_tracker_import_json_data_files: stock_tracker_import_json_data_files;
    stock_tracker_barcode_sheet_history: stock_tracker_barcode_sheet_history;
    stock_tracker_barcode_sheet_history_repid: stock_tracker_barcode_sheet_history_repid;
    stock_tracker_get_barcode_sheet: stock_tracker_get_barcode_sheet;
    stock_tracker_get_manager_names: stock_tracker_get_manager_names;
    stock_tracker_set_carried_product_additions: stock_tracker_set_carried_product_additions;
    stock_tracker_set_product_distribution_order_status: stock_tracker_set_product_distribution_order_status;
    stock_tracker_get_product_additions_by_store: stock_tracker_get_product_additions_by_store;
    stock_tracker_uncarry_product_addition_by_id: stock_tracker_uncarry_product_addition_by_id;
    stock_tracker_log_product_scan: stock_tracker_log_product_scan;
    product_locator_index: product_locator_index;
    product_locator_add_new_products: product_locator_add_new_products;
    product_locator_manage_planograms: product_locator_manage_planograms;
    product_locator_scan_audit: product_locator_scan_audit;
    product_locator_get_product_location: product_locator_get_product_location;
    product_locator_get_product_locations_by_name: product_locator_get_product_locations_by_name;
    product_locator_add_new_product_location: product_locator_add_new_product_location;
    product_locator_add_upc_to_scan_audit: product_locator_add_upc_to_scan_audit;
    product_locator_create_new_scan_audit: product_locator_create_new_scan_audit;
    product_locator_get_planograms_by_store: product_locator_get_planograms_by_store;
    product_locator_delete_planogram: product_locator_delete_planogram;
    product_locator_get_planogram_locations: product_locator_get_planogram_locations;
    product_locator_get_products_from_latest_scan_audit: product_locator_get_products_from_latest_scan_audit;
    survey_worker_index: survey_worker_index;
    survey_worker_qt_admin: survey_worker_qt_admin;
    survey_worker_qt_view_login_sessions: survey_worker_qt_view_login_sessions;
    survey_worker_qt_view_schedules: survey_worker_qt_view_schedules;
    survey_worker_qt_territory_viewer: survey_worker_qt_territory_viewer;
    survey_worker_qt_update_schedule: survey_worker_qt_update_schedule;
    survey_worker_qt_view_autofill_logs: survey_worker_qt_view_autofill_logs;
    survey_worker_qt_force_fetch_login_session: survey_worker_qt_force_fetch_login_session;
    survey_worker_qt_view_rep_schedule: survey_worker_qt_view_rep_schedule;
    survey_worker_qt_log_autofill_message: survey_worker_qt_log_autofill_message;
    __reactivated_do_not_use: __reactivated_do_not_use;
    __reactivated_do_not_use_args: __reactivated_do_not_use_args;
}

interface admin_index {
    name: 'admin:index';
    args: admin_index_args;
}

interface admin_index_args {
}

interface admin_login {
    name: 'admin:login';
    args: admin_login_args;
}

interface admin_login_args {
}

interface admin_logout {
    name: 'admin:logout';
    args: admin_logout_args;
}

interface admin_logout_args {
}

interface admin_password_change {
    name: 'admin:password_change';
    args: admin_password_change_args;
}

interface admin_password_change_args {
}

interface admin_password_change_done {
    name: 'admin:password_change_done';
    args: admin_password_change_done_args;
}

interface admin_password_change_done_args {
}

interface admin_autocomplete {
    name: 'admin:autocomplete';
    args: admin_autocomplete_args;
}

interface admin_autocomplete_args {
}

interface admin_jsi18n {
    name: 'admin:jsi18n';
    args: admin_jsi18n_args;
}

interface admin_jsi18n_args {
}

interface admin_view_on_site {
    name: 'admin:view_on_site';
    args: admin_view_on_site_args;
}

interface admin_view_on_site_args {
    content_type_id: number;
    object_id: string;
}

interface admin_auth_group_changelist {
    name: 'admin:auth_group_changelist';
    args: admin_auth_group_changelist_args;
}

interface admin_auth_group_changelist_args {
}

interface admin_auth_group_add {
    name: 'admin:auth_group_add';
    args: admin_auth_group_add_args;
}

interface admin_auth_group_add_args {
}

interface admin_auth_group_history {
    name: 'admin:auth_group_history';
    args: admin_auth_group_history_args;
}

interface admin_auth_group_history_args {
    object_id: string;
}

interface admin_auth_group_delete {
    name: 'admin:auth_group_delete';
    args: admin_auth_group_delete_args;
}

interface admin_auth_group_delete_args {
    object_id: string;
}

interface admin_auth_group_change {
    name: 'admin:auth_group_change';
    args: admin_auth_group_change_args;
}

interface admin_auth_group_change_args {
    object_id: string;
}

interface admin_auth_group__path_object_id__ {
    name: 'admin/auth/group/<path:object_id>/';
    args: admin_auth_group__path_object_id___args;
}

interface admin_auth_group__path_object_id___args {
    object_id: string;
}

interface admin_auth_user_password_change {
    name: 'admin:auth_user_password_change';
    args: admin_auth_user_password_change_args;
}

interface admin_auth_user_password_change_args {
    id: string;
}

interface admin_auth_user_changelist {
    name: 'admin:auth_user_changelist';
    args: admin_auth_user_changelist_args;
}

interface admin_auth_user_changelist_args {
}

interface admin_auth_user_add {
    name: 'admin:auth_user_add';
    args: admin_auth_user_add_args;
}

interface admin_auth_user_add_args {
}

interface admin_auth_user_history {
    name: 'admin:auth_user_history';
    args: admin_auth_user_history_args;
}

interface admin_auth_user_history_args {
    object_id: string;
}

interface admin_auth_user_delete {
    name: 'admin:auth_user_delete';
    args: admin_auth_user_delete_args;
}

interface admin_auth_user_delete_args {
    object_id: string;
}

interface admin_auth_user_change {
    name: 'admin:auth_user_change';
    args: admin_auth_user_change_args;
}

interface admin_auth_user_change_args {
    object_id: string;
}

interface admin_auth_user__path_object_id__ {
    name: 'admin/auth/user/<path:object_id>/';
    args: admin_auth_user__path_object_id___args;
}

interface admin_auth_user__path_object_id___args {
    object_id: string;
}

interface admin_products_workcycle_changelist {
    name: 'admin:products_workcycle_changelist';
    args: admin_products_workcycle_changelist_args;
}

interface admin_products_workcycle_changelist_args {
}

interface admin_products_workcycle_add {
    name: 'admin:products_workcycle_add';
    args: admin_products_workcycle_add_args;
}

interface admin_products_workcycle_add_args {
}

interface admin_products_workcycle_history {
    name: 'admin:products_workcycle_history';
    args: admin_products_workcycle_history_args;
}

interface admin_products_workcycle_history_args {
    object_id: string;
}

interface admin_products_workcycle_delete {
    name: 'admin:products_workcycle_delete';
    args: admin_products_workcycle_delete_args;
}

interface admin_products_workcycle_delete_args {
    object_id: string;
}

interface admin_products_workcycle_change {
    name: 'admin:products_workcycle_change';
    args: admin_products_workcycle_change_args;
}

interface admin_products_workcycle_change_args {
    object_id: string;
}

interface admin_products_workcycle__path_object_id__ {
    name: 'admin/products/workcycle/<path:object_id>/';
    args: admin_products_workcycle__path_object_id___args;
}

interface admin_products_workcycle__path_object_id___args {
    object_id: string;
}

interface admin_products_fieldrepresentative_changelist {
    name: 'admin:products_fieldrepresentative_changelist';
    args: admin_products_fieldrepresentative_changelist_args;
}

interface admin_products_fieldrepresentative_changelist_args {
}

interface admin_products_fieldrepresentative_add {
    name: 'admin:products_fieldrepresentative_add';
    args: admin_products_fieldrepresentative_add_args;
}

interface admin_products_fieldrepresentative_add_args {
}

interface admin_products_fieldrepresentative_history {
    name: 'admin:products_fieldrepresentative_history';
    args: admin_products_fieldrepresentative_history_args;
}

interface admin_products_fieldrepresentative_history_args {
    object_id: string;
}

interface admin_products_fieldrepresentative_delete {
    name: 'admin:products_fieldrepresentative_delete';
    args: admin_products_fieldrepresentative_delete_args;
}

interface admin_products_fieldrepresentative_delete_args {
    object_id: string;
}

interface admin_products_fieldrepresentative_change {
    name: 'admin:products_fieldrepresentative_change';
    args: admin_products_fieldrepresentative_change_args;
}

interface admin_products_fieldrepresentative_change_args {
    object_id: string;
}

interface admin_products_fieldrepresentative__path_object_id__ {
    name: 'admin/products/fieldrepresentative/<path:object_id>/';
    args: admin_products_fieldrepresentative__path_object_id___args;
}

interface admin_products_fieldrepresentative__path_object_id___args {
    object_id: string;
}

interface admin_products_brandparentcompany_changelist {
    name: 'admin:products_brandparentcompany_changelist';
    args: admin_products_brandparentcompany_changelist_args;
}

interface admin_products_brandparentcompany_changelist_args {
}

interface admin_products_brandparentcompany_add {
    name: 'admin:products_brandparentcompany_add';
    args: admin_products_brandparentcompany_add_args;
}

interface admin_products_brandparentcompany_add_args {
}

interface admin_products_brandparentcompany_history {
    name: 'admin:products_brandparentcompany_history';
    args: admin_products_brandparentcompany_history_args;
}

interface admin_products_brandparentcompany_history_args {
    object_id: string;
}

interface admin_products_brandparentcompany_delete {
    name: 'admin:products_brandparentcompany_delete';
    args: admin_products_brandparentcompany_delete_args;
}

interface admin_products_brandparentcompany_delete_args {
    object_id: string;
}

interface admin_products_brandparentcompany_change {
    name: 'admin:products_brandparentcompany_change';
    args: admin_products_brandparentcompany_change_args;
}

interface admin_products_brandparentcompany_change_args {
    object_id: string;
}

interface admin_products_brandparentcompany__path_object_id__ {
    name: 'admin/products/brandparentcompany/<path:object_id>/';
    args: admin_products_brandparentcompany__path_object_id___args;
}

interface admin_products_brandparentcompany__path_object_id___args {
    object_id: string;
}

interface admin_products_product_changelist {
    name: 'admin:products_product_changelist';
    args: admin_products_product_changelist_args;
}

interface admin_products_product_changelist_args {
}

interface admin_products_product_add {
    name: 'admin:products_product_add';
    args: admin_products_product_add_args;
}

interface admin_products_product_add_args {
}

interface admin_products_product_history {
    name: 'admin:products_product_history';
    args: admin_products_product_history_args;
}

interface admin_products_product_history_args {
    object_id: string;
}

interface admin_products_product_delete {
    name: 'admin:products_product_delete';
    args: admin_products_product_delete_args;
}

interface admin_products_product_delete_args {
    object_id: string;
}

interface admin_products_product_change {
    name: 'admin:products_product_change';
    args: admin_products_product_change_args;
}

interface admin_products_product_change_args {
    object_id: string;
}

interface admin_products_product__path_object_id__ {
    name: 'admin/products/product/<path:object_id>/';
    args: admin_products_product__path_object_id___args;
}

interface admin_products_product__path_object_id___args {
    object_id: string;
}

interface admin_products_storeguid_changelist {
    name: 'admin:products_storeguid_changelist';
    args: admin_products_storeguid_changelist_args;
}

interface admin_products_storeguid_changelist_args {
}

interface admin_products_storeguid_add {
    name: 'admin:products_storeguid_add';
    args: admin_products_storeguid_add_args;
}

interface admin_products_storeguid_add_args {
}

interface admin_products_storeguid_history {
    name: 'admin:products_storeguid_history';
    args: admin_products_storeguid_history_args;
}

interface admin_products_storeguid_history_args {
    object_id: string;
}

interface admin_products_storeguid_delete {
    name: 'admin:products_storeguid_delete';
    args: admin_products_storeguid_delete_args;
}

interface admin_products_storeguid_delete_args {
    object_id: string;
}

interface admin_products_storeguid_change {
    name: 'admin:products_storeguid_change';
    args: admin_products_storeguid_change_args;
}

interface admin_products_storeguid_change_args {
    object_id: string;
}

interface admin_products_storeguid__path_object_id__ {
    name: 'admin/products/storeguid/<path:object_id>/';
    args: admin_products_storeguid__path_object_id___args;
}

interface admin_products_storeguid__path_object_id___args {
    object_id: string;
}

interface admin_products_store_changelist {
    name: 'admin:products_store_changelist';
    args: admin_products_store_changelist_args;
}

interface admin_products_store_changelist_args {
}

interface admin_products_store_add {
    name: 'admin:products_store_add';
    args: admin_products_store_add_args;
}

interface admin_products_store_add_args {
}

interface admin_products_store_history {
    name: 'admin:products_store_history';
    args: admin_products_store_history_args;
}

interface admin_products_store_history_args {
    object_id: string;
}

interface admin_products_store_delete {
    name: 'admin:products_store_delete';
    args: admin_products_store_delete_args;
}

interface admin_products_store_delete_args {
    object_id: string;
}

interface admin_products_store_change {
    name: 'admin:products_store_change';
    args: admin_products_store_change_args;
}

interface admin_products_store_change_args {
    object_id: string;
}

interface admin_products_store__path_object_id__ {
    name: 'admin/products/store/<path:object_id>/';
    args: admin_products_store__path_object_id___args;
}

interface admin_products_store__path_object_id___args {
    object_id: string;
}

interface admin_products_productaddition_changelist {
    name: 'admin:products_productaddition_changelist';
    args: admin_products_productaddition_changelist_args;
}

interface admin_products_productaddition_changelist_args {
}

interface admin_products_productaddition_add {
    name: 'admin:products_productaddition_add';
    args: admin_products_productaddition_add_args;
}

interface admin_products_productaddition_add_args {
}

interface admin_products_productaddition_history {
    name: 'admin:products_productaddition_history';
    args: admin_products_productaddition_history_args;
}

interface admin_products_productaddition_history_args {
    object_id: string;
}

interface admin_products_productaddition_delete {
    name: 'admin:products_productaddition_delete';
    args: admin_products_productaddition_delete_args;
}

interface admin_products_productaddition_delete_args {
    object_id: string;
}

interface admin_products_productaddition_change {
    name: 'admin:products_productaddition_change';
    args: admin_products_productaddition_change_args;
}

interface admin_products_productaddition_change_args {
    object_id: string;
}

interface admin_products_productaddition__path_object_id__ {
    name: 'admin/products/productaddition/<path:object_id>/';
    args: admin_products_productaddition__path_object_id___args;
}

interface admin_products_productaddition__path_object_id___args {
    object_id: string;
}

interface admin_products_personnelcontact_changelist {
    name: 'admin:products_personnelcontact_changelist';
    args: admin_products_personnelcontact_changelist_args;
}

interface admin_products_personnelcontact_changelist_args {
}

interface admin_products_personnelcontact_add {
    name: 'admin:products_personnelcontact_add';
    args: admin_products_personnelcontact_add_args;
}

interface admin_products_personnelcontact_add_args {
}

interface admin_products_personnelcontact_history {
    name: 'admin:products_personnelcontact_history';
    args: admin_products_personnelcontact_history_args;
}

interface admin_products_personnelcontact_history_args {
    object_id: string;
}

interface admin_products_personnelcontact_delete {
    name: 'admin:products_personnelcontact_delete';
    args: admin_products_personnelcontact_delete_args;
}

interface admin_products_personnelcontact_delete_args {
    object_id: string;
}

interface admin_products_personnelcontact_change {
    name: 'admin:products_personnelcontact_change';
    args: admin_products_personnelcontact_change_args;
}

interface admin_products_personnelcontact_change_args {
    object_id: string;
}

interface admin_products_personnelcontact__path_object_id__ {
    name: 'admin/products/personnelcontact/<path:object_id>/';
    args: admin_products_personnelcontact__path_object_id___args;
}

interface admin_products_personnelcontact__path_object_id___args {
    object_id: string;
}

interface admin_products_barcodesheet_changelist {
    name: 'admin:products_barcodesheet_changelist';
    args: admin_products_barcodesheet_changelist_args;
}

interface admin_products_barcodesheet_changelist_args {
}

interface admin_products_barcodesheet_add {
    name: 'admin:products_barcodesheet_add';
    args: admin_products_barcodesheet_add_args;
}

interface admin_products_barcodesheet_add_args {
}

interface admin_products_barcodesheet_history {
    name: 'admin:products_barcodesheet_history';
    args: admin_products_barcodesheet_history_args;
}

interface admin_products_barcodesheet_history_args {
    object_id: string;
}

interface admin_products_barcodesheet_delete {
    name: 'admin:products_barcodesheet_delete';
    args: admin_products_barcodesheet_delete_args;
}

interface admin_products_barcodesheet_delete_args {
    object_id: string;
}

interface admin_products_barcodesheet_change {
    name: 'admin:products_barcodesheet_change';
    args: admin_products_barcodesheet_change_args;
}

interface admin_products_barcodesheet_change_args {
    object_id: string;
}

interface admin_products_barcodesheet__path_object_id__ {
    name: 'admin/products/barcodesheet/<path:object_id>/';
    args: admin_products_barcodesheet__path_object_id___args;
}

interface admin_products_barcodesheet__path_object_id___args {
    object_id: string;
}

interface admin_product_locator_planogram_changelist {
    name: 'admin:product_locator_planogram_changelist';
    args: admin_product_locator_planogram_changelist_args;
}

interface admin_product_locator_planogram_changelist_args {
}

interface admin_product_locator_planogram_add {
    name: 'admin:product_locator_planogram_add';
    args: admin_product_locator_planogram_add_args;
}

interface admin_product_locator_planogram_add_args {
}

interface admin_product_locator_planogram_history {
    name: 'admin:product_locator_planogram_history';
    args: admin_product_locator_planogram_history_args;
}

interface admin_product_locator_planogram_history_args {
    object_id: string;
}

interface admin_product_locator_planogram_delete {
    name: 'admin:product_locator_planogram_delete';
    args: admin_product_locator_planogram_delete_args;
}

interface admin_product_locator_planogram_delete_args {
    object_id: string;
}

interface admin_product_locator_planogram_change {
    name: 'admin:product_locator_planogram_change';
    args: admin_product_locator_planogram_change_args;
}

interface admin_product_locator_planogram_change_args {
    object_id: string;
}

interface admin_product_locator_planogram__path_object_id__ {
    name: 'admin/product_locator/planogram/<path:object_id>/';
    args: admin_product_locator_planogram__path_object_id___args;
}

interface admin_product_locator_planogram__path_object_id___args {
    object_id: string;
}

interface admin_product_locator_homelocation_changelist {
    name: 'admin:product_locator_homelocation_changelist';
    args: admin_product_locator_homelocation_changelist_args;
}

interface admin_product_locator_homelocation_changelist_args {
}

interface admin_product_locator_homelocation_add {
    name: 'admin:product_locator_homelocation_add';
    args: admin_product_locator_homelocation_add_args;
}

interface admin_product_locator_homelocation_add_args {
}

interface admin_product_locator_homelocation_history {
    name: 'admin:product_locator_homelocation_history';
    args: admin_product_locator_homelocation_history_args;
}

interface admin_product_locator_homelocation_history_args {
    object_id: string;
}

interface admin_product_locator_homelocation_delete {
    name: 'admin:product_locator_homelocation_delete';
    args: admin_product_locator_homelocation_delete_args;
}

interface admin_product_locator_homelocation_delete_args {
    object_id: string;
}

interface admin_product_locator_homelocation_change {
    name: 'admin:product_locator_homelocation_change';
    args: admin_product_locator_homelocation_change_args;
}

interface admin_product_locator_homelocation_change_args {
    object_id: string;
}

interface admin_product_locator_homelocation__path_object_id__ {
    name: 'admin/product_locator/homelocation/<path:object_id>/';
    args: admin_product_locator_homelocation__path_object_id___args;
}

interface admin_product_locator_homelocation__path_object_id___args {
    object_id: string;
}

interface admin_product_locator_product_changelist {
    name: 'admin:product_locator_product_changelist';
    args: admin_product_locator_product_changelist_args;
}

interface admin_product_locator_product_changelist_args {
}

interface admin_product_locator_product_add {
    name: 'admin:product_locator_product_add';
    args: admin_product_locator_product_add_args;
}

interface admin_product_locator_product_add_args {
}

interface admin_product_locator_product_history {
    name: 'admin:product_locator_product_history';
    args: admin_product_locator_product_history_args;
}

interface admin_product_locator_product_history_args {
    object_id: string;
}

interface admin_product_locator_product_delete {
    name: 'admin:product_locator_product_delete';
    args: admin_product_locator_product_delete_args;
}

interface admin_product_locator_product_delete_args {
    object_id: string;
}

interface admin_product_locator_product_change {
    name: 'admin:product_locator_product_change';
    args: admin_product_locator_product_change_args;
}

interface admin_product_locator_product_change_args {
    object_id: string;
}

interface admin_product_locator_product__path_object_id__ {
    name: 'admin/product_locator/product/<path:object_id>/';
    args: admin_product_locator_product__path_object_id___args;
}

interface admin_product_locator_product__path_object_id___args {
    object_id: string;
}

interface admin_product_locator_productscanaudit_changelist {
    name: 'admin:product_locator_productscanaudit_changelist';
    args: admin_product_locator_productscanaudit_changelist_args;
}

interface admin_product_locator_productscanaudit_changelist_args {
}

interface admin_product_locator_productscanaudit_add {
    name: 'admin:product_locator_productscanaudit_add';
    args: admin_product_locator_productscanaudit_add_args;
}

interface admin_product_locator_productscanaudit_add_args {
}

interface admin_product_locator_productscanaudit_history {
    name: 'admin:product_locator_productscanaudit_history';
    args: admin_product_locator_productscanaudit_history_args;
}

interface admin_product_locator_productscanaudit_history_args {
    object_id: string;
}

interface admin_product_locator_productscanaudit_delete {
    name: 'admin:product_locator_productscanaudit_delete';
    args: admin_product_locator_productscanaudit_delete_args;
}

interface admin_product_locator_productscanaudit_delete_args {
    object_id: string;
}

interface admin_product_locator_productscanaudit_change {
    name: 'admin:product_locator_productscanaudit_change';
    args: admin_product_locator_productscanaudit_change_args;
}

interface admin_product_locator_productscanaudit_change_args {
    object_id: string;
}

interface admin_product_locator_productscanaudit__path_object_id__ {
    name: 'admin/product_locator/productscanaudit/<path:object_id>/';
    args: admin_product_locator_productscanaudit__path_object_id___args;
}

interface admin_product_locator_productscanaudit__path_object_id___args {
    object_id: string;
}

interface admin_product_locator_store_changelist {
    name: 'admin:product_locator_store_changelist';
    args: admin_product_locator_store_changelist_args;
}

interface admin_product_locator_store_changelist_args {
}

interface admin_product_locator_store_add {
    name: 'admin:product_locator_store_add';
    args: admin_product_locator_store_add_args;
}

interface admin_product_locator_store_add_args {
}

interface admin_product_locator_store_history {
    name: 'admin:product_locator_store_history';
    args: admin_product_locator_store_history_args;
}

interface admin_product_locator_store_history_args {
    object_id: string;
}

interface admin_product_locator_store_delete {
    name: 'admin:product_locator_store_delete';
    args: admin_product_locator_store_delete_args;
}

interface admin_product_locator_store_delete_args {
    object_id: string;
}

interface admin_product_locator_store_change {
    name: 'admin:product_locator_store_change';
    args: admin_product_locator_store_change_args;
}

interface admin_product_locator_store_change_args {
    object_id: string;
}

interface admin_product_locator_store__path_object_id__ {
    name: 'admin/product_locator/store/<path:object_id>/';
    args: admin_product_locator_store__path_object_id___args;
}

interface admin_product_locator_store__path_object_id___args {
    object_id: string;
}

interface admin_survey_worker_qtrepdetail_changelist {
    name: 'admin:survey_worker_qtrepdetail_changelist';
    args: admin_survey_worker_qtrepdetail_changelist_args;
}

interface admin_survey_worker_qtrepdetail_changelist_args {
}

interface admin_survey_worker_qtrepdetail_add {
    name: 'admin:survey_worker_qtrepdetail_add';
    args: admin_survey_worker_qtrepdetail_add_args;
}

interface admin_survey_worker_qtrepdetail_add_args {
}

interface admin_survey_worker_qtrepdetail_history {
    name: 'admin:survey_worker_qtrepdetail_history';
    args: admin_survey_worker_qtrepdetail_history_args;
}

interface admin_survey_worker_qtrepdetail_history_args {
    object_id: string;
}

interface admin_survey_worker_qtrepdetail_delete {
    name: 'admin:survey_worker_qtrepdetail_delete';
    args: admin_survey_worker_qtrepdetail_delete_args;
}

interface admin_survey_worker_qtrepdetail_delete_args {
    object_id: string;
}

interface admin_survey_worker_qtrepdetail_change {
    name: 'admin:survey_worker_qtrepdetail_change';
    args: admin_survey_worker_qtrepdetail_change_args;
}

interface admin_survey_worker_qtrepdetail_change_args {
    object_id: string;
}

interface admin_survey_worker_qtrepdetail__path_object_id__ {
    name: 'admin/survey_worker/qtrepdetail/<path:object_id>/';
    args: admin_survey_worker_qtrepdetail__path_object_id___args;
}

interface admin_survey_worker_qtrepdetail__path_object_id___args {
    object_id: string;
}

interface admin_survey_worker_qtloginsession_changelist {
    name: 'admin:survey_worker_qtloginsession_changelist';
    args: admin_survey_worker_qtloginsession_changelist_args;
}

interface admin_survey_worker_qtloginsession_changelist_args {
}

interface admin_survey_worker_qtloginsession_add {
    name: 'admin:survey_worker_qtloginsession_add';
    args: admin_survey_worker_qtloginsession_add_args;
}

interface admin_survey_worker_qtloginsession_add_args {
}

interface admin_survey_worker_qtloginsession_history {
    name: 'admin:survey_worker_qtloginsession_history';
    args: admin_survey_worker_qtloginsession_history_args;
}

interface admin_survey_worker_qtloginsession_history_args {
    object_id: string;
}

interface admin_survey_worker_qtloginsession_delete {
    name: 'admin:survey_worker_qtloginsession_delete';
    args: admin_survey_worker_qtloginsession_delete_args;
}

interface admin_survey_worker_qtloginsession_delete_args {
    object_id: string;
}

interface admin_survey_worker_qtloginsession_change {
    name: 'admin:survey_worker_qtloginsession_change';
    args: admin_survey_worker_qtloginsession_change_args;
}

interface admin_survey_worker_qtloginsession_change_args {
    object_id: string;
}

interface admin_survey_worker_qtloginsession__path_object_id__ {
    name: 'admin/survey_worker/qtloginsession/<path:object_id>/';
    args: admin_survey_worker_qtloginsession__path_object_id___args;
}

interface admin_survey_worker_qtloginsession__path_object_id___args {
    object_id: string;
}

interface admin_survey_worker_qtjob_changelist {
    name: 'admin:survey_worker_qtjob_changelist';
    args: admin_survey_worker_qtjob_changelist_args;
}

interface admin_survey_worker_qtjob_changelist_args {
}

interface admin_survey_worker_qtjob_add {
    name: 'admin:survey_worker_qtjob_add';
    args: admin_survey_worker_qtjob_add_args;
}

interface admin_survey_worker_qtjob_add_args {
}

interface admin_survey_worker_qtjob_history {
    name: 'admin:survey_worker_qtjob_history';
    args: admin_survey_worker_qtjob_history_args;
}

interface admin_survey_worker_qtjob_history_args {
    object_id: string;
}

interface admin_survey_worker_qtjob_delete {
    name: 'admin:survey_worker_qtjob_delete';
    args: admin_survey_worker_qtjob_delete_args;
}

interface admin_survey_worker_qtjob_delete_args {
    object_id: string;
}

interface admin_survey_worker_qtjob_change {
    name: 'admin:survey_worker_qtjob_change';
    args: admin_survey_worker_qtjob_change_args;
}

interface admin_survey_worker_qtjob_change_args {
    object_id: string;
}

interface admin_survey_worker_qtjob__path_object_id__ {
    name: 'admin/survey_worker/qtjob/<path:object_id>/';
    args: admin_survey_worker_qtjob__path_object_id___args;
}

interface admin_survey_worker_qtjob__path_object_id___args {
    object_id: string;
}

interface admin_survey_worker_qtsyncdata_changelist {
    name: 'admin:survey_worker_qtsyncdata_changelist';
    args: admin_survey_worker_qtsyncdata_changelist_args;
}

interface admin_survey_worker_qtsyncdata_changelist_args {
}

interface admin_survey_worker_qtsyncdata_add {
    name: 'admin:survey_worker_qtsyncdata_add';
    args: admin_survey_worker_qtsyncdata_add_args;
}

interface admin_survey_worker_qtsyncdata_add_args {
}

interface admin_survey_worker_qtsyncdata_history {
    name: 'admin:survey_worker_qtsyncdata_history';
    args: admin_survey_worker_qtsyncdata_history_args;
}

interface admin_survey_worker_qtsyncdata_history_args {
    object_id: string;
}

interface admin_survey_worker_qtsyncdata_delete {
    name: 'admin:survey_worker_qtsyncdata_delete';
    args: admin_survey_worker_qtsyncdata_delete_args;
}

interface admin_survey_worker_qtsyncdata_delete_args {
    object_id: string;
}

interface admin_survey_worker_qtsyncdata_change {
    name: 'admin:survey_worker_qtsyncdata_change';
    args: admin_survey_worker_qtsyncdata_change_args;
}

interface admin_survey_worker_qtsyncdata_change_args {
    object_id: string;
}

interface admin_survey_worker_qtsyncdata__path_object_id__ {
    name: 'admin/survey_worker/qtsyncdata/<path:object_id>/';
    args: admin_survey_worker_qtsyncdata__path_object_id___args;
}

interface admin_survey_worker_qtsyncdata__path_object_id___args {
    object_id: string;
}

interface admin_survey_worker_qtserviceorder_changelist {
    name: 'admin:survey_worker_qtserviceorder_changelist';
    args: admin_survey_worker_qtserviceorder_changelist_args;
}

interface admin_survey_worker_qtserviceorder_changelist_args {
}

interface admin_survey_worker_qtserviceorder_add {
    name: 'admin:survey_worker_qtserviceorder_add';
    args: admin_survey_worker_qtserviceorder_add_args;
}

interface admin_survey_worker_qtserviceorder_add_args {
}

interface admin_survey_worker_qtserviceorder_history {
    name: 'admin:survey_worker_qtserviceorder_history';
    args: admin_survey_worker_qtserviceorder_history_args;
}

interface admin_survey_worker_qtserviceorder_history_args {
    object_id: string;
}

interface admin_survey_worker_qtserviceorder_delete {
    name: 'admin:survey_worker_qtserviceorder_delete';
    args: admin_survey_worker_qtserviceorder_delete_args;
}

interface admin_survey_worker_qtserviceorder_delete_args {
    object_id: string;
}

interface admin_survey_worker_qtserviceorder_change {
    name: 'admin:survey_worker_qtserviceorder_change';
    args: admin_survey_worker_qtserviceorder_change_args;
}

interface admin_survey_worker_qtserviceorder_change_args {
    object_id: string;
}

interface admin_survey_worker_qtserviceorder__path_object_id__ {
    name: 'admin/survey_worker/qtserviceorder/<path:object_id>/';
    args: admin_survey_worker_qtserviceorder__path_object_id___args;
}

interface admin_survey_worker_qtserviceorder__path_object_id___args {
    object_id: string;
}

interface admin_survey_worker_globalsettings_changelist {
    name: 'admin:survey_worker_globalsettings_changelist';
    args: admin_survey_worker_globalsettings_changelist_args;
}

interface admin_survey_worker_globalsettings_changelist_args {
}

interface admin_survey_worker_globalsettings_add {
    name: 'admin:survey_worker_globalsettings_add';
    args: admin_survey_worker_globalsettings_add_args;
}

interface admin_survey_worker_globalsettings_add_args {
}

interface admin_survey_worker_globalsettings_history {
    name: 'admin:survey_worker_globalsettings_history';
    args: admin_survey_worker_globalsettings_history_args;
}

interface admin_survey_worker_globalsettings_history_args {
    object_id: string;
}

interface admin_survey_worker_globalsettings_delete {
    name: 'admin:survey_worker_globalsettings_delete';
    args: admin_survey_worker_globalsettings_delete_args;
}

interface admin_survey_worker_globalsettings_delete_args {
    object_id: string;
}

interface admin_survey_worker_globalsettings_change {
    name: 'admin:survey_worker_globalsettings_change';
    args: admin_survey_worker_globalsettings_change_args;
}

interface admin_survey_worker_globalsettings_change_args {
    object_id: string;
}

interface admin_survey_worker_globalsettings__path_object_id__ {
    name: 'admin/survey_worker/globalsettings/<path:object_id>/';
    args: admin_survey_worker_globalsettings__path_object_id___args;
}

interface admin_survey_worker_globalsettings__path_object_id___args {
    object_id: string;
}

interface admin_authtoken_tokenproxy_changelist {
    name: 'admin:authtoken_tokenproxy_changelist';
    args: admin_authtoken_tokenproxy_changelist_args;
}

interface admin_authtoken_tokenproxy_changelist_args {
}

interface admin_authtoken_tokenproxy_add {
    name: 'admin:authtoken_tokenproxy_add';
    args: admin_authtoken_tokenproxy_add_args;
}

interface admin_authtoken_tokenproxy_add_args {
}

interface admin_authtoken_tokenproxy_history {
    name: 'admin:authtoken_tokenproxy_history';
    args: admin_authtoken_tokenproxy_history_args;
}

interface admin_authtoken_tokenproxy_history_args {
    object_id: string;
}

interface admin_authtoken_tokenproxy_delete {
    name: 'admin:authtoken_tokenproxy_delete';
    args: admin_authtoken_tokenproxy_delete_args;
}

interface admin_authtoken_tokenproxy_delete_args {
    object_id: string;
}

interface admin_authtoken_tokenproxy_change {
    name: 'admin:authtoken_tokenproxy_change';
    args: admin_authtoken_tokenproxy_change_args;
}

interface admin_authtoken_tokenproxy_change_args {
    object_id: string;
}

interface admin_authtoken_tokenproxy__path_object_id__ {
    name: 'admin/authtoken/tokenproxy/<path:object_id>/';
    args: admin_authtoken_tokenproxy__path_object_id___args;
}

interface admin_authtoken_tokenproxy__path_object_id___args {
    object_id: string;
}

interface root_index {
    name: 'root:index';
    args: root_index_args;
}

interface root_index_args {
}

interface api_validate_api_token {
    name: 'api:validate_api_token';
    args: api_validate_api_token_args;
}

interface api_validate_api_token_args {
}

interface api_get_store_product_additions {
    name: 'api:get_store_product_additions';
    args: api_get_store_product_additions_args;
}

interface api_get_store_product_additions_args {
}

interface api_get_field_reps {
    name: 'api:get_field_reps';
    args: api_get_field_reps_args;
}

interface api_get_field_reps_args {
}

interface api_update_store_field_rep {
    name: 'api:update_store_field_rep';
    args: api_update_store_field_rep_args;
}

interface api_update_store_field_rep_args {
}

interface api_update_store_personnel {
    name: 'api:update_store_personnel';
    args: api_update_store_personnel_args;
}

interface api_update_store_personnel_args {
}

interface api_update_cmk_html_src {
    name: 'api:update_cmk_html_src';
    args: api_update_cmk_html_src_args;
}

interface api_update_cmk_html_src_args {
}

interface api_get_service_order_info {
    name: 'api:get_service_order_info';
    args: api_get_service_order_info_args;
}

interface api_get_service_order_info_args {
    soid: number;
}

interface stock_tracker_scanner {
    name: 'stock_tracker:scanner';
    args: stock_tracker_scanner_args;
}

interface stock_tracker_scanner_args {
}

interface stock_tracker_login_view {
    name: 'stock_tracker:login_view';
    args: stock_tracker_login_view_args;
}

interface stock_tracker_login_view_args {
}

interface stock_tracker_logout_view {
    name: 'stock_tracker:logout_view';
    args: stock_tracker_logout_view_args;
}

interface stock_tracker_logout_view_args {
}

interface stock_tracker_add_new_stores {
    name: 'stock_tracker:add_new_stores';
    args: stock_tracker_add_new_stores_args;
}

interface stock_tracker_add_new_stores_args {
}

interface stock_tracker_scan_history {
    name: 'stock_tracker:scan_history';
    args: stock_tracker_scan_history_args;
}

interface stock_tracker_scan_history_args {
}

interface stock_tracker_uncarry_product_addition {
    name: 'stock_tracker:uncarry_product_addition';
    args: stock_tracker_uncarry_product_addition_args;
}

interface stock_tracker_uncarry_product_addition_args {
    product_addition_pk: number;
}

interface stock_tracker_import_json_data_files {
    name: 'stock_tracker:import_json_data_files';
    args: stock_tracker_import_json_data_files_args;
}

interface stock_tracker_import_json_data_files_args {
}

interface stock_tracker_barcode_sheet_history {
    name: 'stock_tracker:barcode_sheet_history';
    args: stock_tracker_barcode_sheet_history_args;
}

interface stock_tracker_barcode_sheet_history_args {
}

interface stock_tracker_barcode_sheet_history_repid {
    name: 'stock_tracker:barcode_sheet_history_repid';
    args: stock_tracker_barcode_sheet_history_repid_args;
}

interface stock_tracker_barcode_sheet_history_repid_args {
    field_representative_id: number;
}

interface stock_tracker_get_barcode_sheet {
    name: 'stock_tracker:get_barcode_sheet';
    args: stock_tracker_get_barcode_sheet_args;
}

interface stock_tracker_get_barcode_sheet_args {
    barcode_sheet_id: number;
}

interface stock_tracker_get_manager_names {
    name: 'stock_tracker:get_manager_names';
    args: stock_tracker_get_manager_names_args;
}

interface stock_tracker_get_manager_names_args {
}

interface stock_tracker_set_carried_product_additions {
    name: 'stock_tracker:set_carried_product_additions';
    args: stock_tracker_set_carried_product_additions_args;
}

interface stock_tracker_set_carried_product_additions_args {
}

interface stock_tracker_set_product_distribution_order_status {
    name: 'stock_tracker:set_product_distribution_order_status';
    args: stock_tracker_set_product_distribution_order_status_args;
}

interface stock_tracker_set_product_distribution_order_status_args {
}

interface stock_tracker_get_product_additions_by_store {
    name: 'stock_tracker:get_product_additions_by_store';
    args: stock_tracker_get_product_additions_by_store_args;
}

interface stock_tracker_get_product_additions_by_store_args {
}

interface stock_tracker_uncarry_product_addition_by_id {
    name: 'stock_tracker:uncarry_product_addition_by_id';
    args: stock_tracker_uncarry_product_addition_by_id_args;
}

interface stock_tracker_uncarry_product_addition_by_id_args {
}

interface stock_tracker_log_product_scan {
    name: 'stock_tracker:log_product_scan';
    args: stock_tracker_log_product_scan_args;
}

interface stock_tracker_log_product_scan_args {
}

interface product_locator_index {
    name: 'product_locator:index';
    args: product_locator_index_args;
}

interface product_locator_index_args {
}

interface product_locator_add_new_products {
    name: 'product_locator:add_new_products';
    args: product_locator_add_new_products_args;
}

interface product_locator_add_new_products_args {
}

interface product_locator_manage_planograms {
    name: 'product_locator:manage_planograms';
    args: product_locator_manage_planograms_args;
}

interface product_locator_manage_planograms_args {
}

interface product_locator_scan_audit {
    name: 'product_locator:scan_audit';
    args: product_locator_scan_audit_args;
}

interface product_locator_scan_audit_args {
}

interface product_locator_get_product_location {
    name: 'product_locator:get_product_location';
    args: product_locator_get_product_location_args;
}

interface product_locator_get_product_location_args {
}

interface product_locator_get_product_locations_by_name {
    name: 'product_locator:get_product_locations_by_name';
    args: product_locator_get_product_locations_by_name_args;
}

interface product_locator_get_product_locations_by_name_args {
    store_id: number;
    product_name: string;
}

interface product_locator_add_new_product_location {
    name: 'product_locator:add_new_product_location';
    args: product_locator_add_new_product_location_args;
}

interface product_locator_add_new_product_location_args {
}

interface product_locator_add_upc_to_scan_audit {
    name: 'product_locator:add_upc_to_scan_audit';
    args: product_locator_add_upc_to_scan_audit_args;
}

interface product_locator_add_upc_to_scan_audit_args {
}

interface product_locator_create_new_scan_audit {
    name: 'product_locator:create_new_scan_audit';
    args: product_locator_create_new_scan_audit_args;
}

interface product_locator_create_new_scan_audit_args {
}

interface product_locator_get_planograms_by_store {
    name: 'product_locator:get_planograms_by_store';
    args: product_locator_get_planograms_by_store_args;
}

interface product_locator_get_planograms_by_store_args {
    store_id: number;
}

interface product_locator_delete_planogram {
    name: 'product_locator:delete_planogram';
    args: product_locator_delete_planogram_args;
}

interface product_locator_delete_planogram_args {
    planogram_id: number;
}

interface product_locator_get_planogram_locations {
    name: 'product_locator:get_planogram_locations';
    args: product_locator_get_planogram_locations_args;
}

interface product_locator_get_planogram_locations_args {
}

interface product_locator_get_products_from_latest_scan_audit {
    name: 'product_locator:get_products_from_latest_scan_audit';
    args: product_locator_get_products_from_latest_scan_audit_args;
}

interface product_locator_get_products_from_latest_scan_audit_args {
}

interface survey_worker_index {
    name: 'survey_worker:index';
    args: survey_worker_index_args;
}

interface survey_worker_index_args {
}

interface survey_worker_qt_admin {
    name: 'survey_worker:qt_admin';
    args: survey_worker_qt_admin_args;
}

interface survey_worker_qt_admin_args {
}

interface survey_worker_qt_view_login_sessions {
    name: 'survey_worker:qt_view_login_sessions';
    args: survey_worker_qt_view_login_sessions_args;
}

interface survey_worker_qt_view_login_sessions_args {
}

interface survey_worker_qt_view_schedules {
    name: 'survey_worker:qt_view_schedules';
    args: survey_worker_qt_view_schedules_args;
}

interface survey_worker_qt_view_schedules_args {
}

interface survey_worker_qt_territory_viewer {
    name: 'survey_worker:qt_territory_viewer';
    args: survey_worker_qt_territory_viewer_args;
}

interface survey_worker_qt_territory_viewer_args {
}

interface survey_worker_qt_update_schedule {
    name: 'survey_worker:qt_update_schedule';
    args: survey_worker_qt_update_schedule_args;
}

interface survey_worker_qt_update_schedule_args {
}

interface survey_worker_qt_view_autofill_logs {
    name: 'survey_worker:qt_view_autofill_logs';
    args: survey_worker_qt_view_autofill_logs_args;
}

interface survey_worker_qt_view_autofill_logs_args {
}

interface survey_worker_qt_force_fetch_login_session {
    name: 'survey_worker:qt_force_fetch_login_session';
    args: survey_worker_qt_force_fetch_login_session_args;
}

interface survey_worker_qt_force_fetch_login_session_args {
    rep_id: number;
}

interface survey_worker_qt_view_rep_schedule {
    name: 'survey_worker:qt_view_rep_schedule';
    args: survey_worker_qt_view_rep_schedule_args;
}

interface survey_worker_qt_view_rep_schedule_args {
    rep_id: number;
}

interface survey_worker_qt_log_autofill_message {
    name: 'survey_worker:qt_log_autofill_message';
    args: survey_worker_qt_log_autofill_message_args;
}

interface survey_worker_qt_log_autofill_message_args {
}

interface __reactivated_do_not_use {
    name: '__reactivated_do_not_use';
    args: __reactivated_do_not_use_args;
}

interface __reactivated_do_not_use_args {
}

interface __reactivated_do_not_use_args {
    name: '__reactivated_do_not_use_args';
    args: __reactivated_do_not_use_args_args;
}

interface __reactivated_do_not_use_args_args {
    _: string;
}

type WithArguments = |admin_view_on_site|admin_auth_group_history|admin_auth_group_delete|admin_auth_group_change|admin_auth_group__path_object_id__|admin_auth_user_password_change|admin_auth_user_history|admin_auth_user_delete|admin_auth_user_change|admin_auth_user__path_object_id__|admin_products_workcycle_history|admin_products_workcycle_delete|admin_products_workcycle_change|admin_products_workcycle__path_object_id__|admin_products_fieldrepresentative_history|admin_products_fieldrepresentative_delete|admin_products_fieldrepresentative_change|admin_products_fieldrepresentative__path_object_id__|admin_products_brandparentcompany_history|admin_products_brandparentcompany_delete|admin_products_brandparentcompany_change|admin_products_brandparentcompany__path_object_id__|admin_products_product_history|admin_products_product_delete|admin_products_product_change|admin_products_product__path_object_id__|admin_products_storeguid_history|admin_products_storeguid_delete|admin_products_storeguid_change|admin_products_storeguid__path_object_id__|admin_products_store_history|admin_products_store_delete|admin_products_store_change|admin_products_store__path_object_id__|admin_products_productaddition_history|admin_products_productaddition_delete|admin_products_productaddition_change|admin_products_productaddition__path_object_id__|admin_products_personnelcontact_history|admin_products_personnelcontact_delete|admin_products_personnelcontact_change|admin_products_personnelcontact__path_object_id__|admin_products_barcodesheet_history|admin_products_barcodesheet_delete|admin_products_barcodesheet_change|admin_products_barcodesheet__path_object_id__|admin_product_locator_planogram_history|admin_product_locator_planogram_delete|admin_product_locator_planogram_change|admin_product_locator_planogram__path_object_id__|admin_product_locator_homelocation_history|admin_product_locator_homelocation_delete|admin_product_locator_homelocation_change|admin_product_locator_homelocation__path_object_id__|admin_product_locator_product_history|admin_product_locator_product_delete|admin_product_locator_product_change|admin_product_locator_product__path_object_id__|admin_product_locator_productscanaudit_history|admin_product_locator_productscanaudit_delete|admin_product_locator_productscanaudit_change|admin_product_locator_productscanaudit__path_object_id__|admin_product_locator_store_history|admin_product_locator_store_delete|admin_product_locator_store_change|admin_product_locator_store__path_object_id__|admin_survey_worker_qtrepdetail_history|admin_survey_worker_qtrepdetail_delete|admin_survey_worker_qtrepdetail_change|admin_survey_worker_qtrepdetail__path_object_id__|admin_survey_worker_qtloginsession_history|admin_survey_worker_qtloginsession_delete|admin_survey_worker_qtloginsession_change|admin_survey_worker_qtloginsession__path_object_id__|admin_survey_worker_qtjob_history|admin_survey_worker_qtjob_delete|admin_survey_worker_qtjob_change|admin_survey_worker_qtjob__path_object_id__|admin_survey_worker_qtsyncdata_history|admin_survey_worker_qtsyncdata_delete|admin_survey_worker_qtsyncdata_change|admin_survey_worker_qtsyncdata__path_object_id__|admin_survey_worker_qtserviceorder_history|admin_survey_worker_qtserviceorder_delete|admin_survey_worker_qtserviceorder_change|admin_survey_worker_qtserviceorder__path_object_id__|admin_survey_worker_globalsettings_history|admin_survey_worker_globalsettings_delete|admin_survey_worker_globalsettings_change|admin_survey_worker_globalsettings__path_object_id__|admin_authtoken_tokenproxy_history|admin_authtoken_tokenproxy_delete|admin_authtoken_tokenproxy_change|admin_authtoken_tokenproxy__path_object_id__|api_get_service_order_info|stock_tracker_uncarry_product_addition|stock_tracker_barcode_sheet_history_repid|stock_tracker_get_barcode_sheet|product_locator_get_product_locations_by_name|product_locator_get_planograms_by_store|product_locator_delete_planogram|survey_worker_qt_force_fetch_login_session|survey_worker_qt_view_rep_schedule|__reactivated_do_not_use_args;
type WithoutArguments = |admin_index|admin_login|admin_logout|admin_password_change|admin_password_change_done|admin_autocomplete|admin_jsi18n|admin_auth_group_changelist|admin_auth_group_add|admin_auth_user_changelist|admin_auth_user_add|admin_products_workcycle_changelist|admin_products_workcycle_add|admin_products_fieldrepresentative_changelist|admin_products_fieldrepresentative_add|admin_products_brandparentcompany_changelist|admin_products_brandparentcompany_add|admin_products_product_changelist|admin_products_product_add|admin_products_storeguid_changelist|admin_products_storeguid_add|admin_products_store_changelist|admin_products_store_add|admin_products_productaddition_changelist|admin_products_productaddition_add|admin_products_personnelcontact_changelist|admin_products_personnelcontact_add|admin_products_barcodesheet_changelist|admin_products_barcodesheet_add|admin_product_locator_planogram_changelist|admin_product_locator_planogram_add|admin_product_locator_homelocation_changelist|admin_product_locator_homelocation_add|admin_product_locator_product_changelist|admin_product_locator_product_add|admin_product_locator_productscanaudit_changelist|admin_product_locator_productscanaudit_add|admin_product_locator_store_changelist|admin_product_locator_store_add|admin_survey_worker_qtrepdetail_changelist|admin_survey_worker_qtrepdetail_add|admin_survey_worker_qtloginsession_changelist|admin_survey_worker_qtloginsession_add|admin_survey_worker_qtjob_changelist|admin_survey_worker_qtjob_add|admin_survey_worker_qtsyncdata_changelist|admin_survey_worker_qtsyncdata_add|admin_survey_worker_qtserviceorder_changelist|admin_survey_worker_qtserviceorder_add|admin_survey_worker_globalsettings_changelist|admin_survey_worker_globalsettings_add|admin_authtoken_tokenproxy_changelist|admin_authtoken_tokenproxy_add|root_index|api_validate_api_token|api_get_store_product_additions|api_get_field_reps|api_update_store_field_rep|api_update_store_personnel|api_update_cmk_html_src|stock_tracker_scanner|stock_tracker_login_view|stock_tracker_logout_view|stock_tracker_add_new_stores|stock_tracker_scan_history|stock_tracker_import_json_data_files|stock_tracker_barcode_sheet_history|stock_tracker_get_manager_names|stock_tracker_set_carried_product_additions|stock_tracker_set_product_distribution_order_status|stock_tracker_get_product_additions_by_store|stock_tracker_uncarry_product_addition_by_id|stock_tracker_log_product_scan|product_locator_index|product_locator_add_new_products|product_locator_manage_planograms|product_locator_scan_audit|product_locator_get_product_location|product_locator_add_new_product_location|product_locator_add_upc_to_scan_audit|product_locator_create_new_scan_audit|product_locator_get_planogram_locations|product_locator_get_products_from_latest_scan_audit|survey_worker_index|survey_worker_qt_admin|survey_worker_qt_view_login_sessions|survey_worker_qt_view_schedules|survey_worker_qt_territory_viewer|survey_worker_qt_update_schedule|survey_worker_qt_view_autofill_logs|survey_worker_qt_log_autofill_message|__reactivated_do_not_use;


    type All = WithArguments|WithoutArguments;
    export function reverse<T extends WithoutArguments['name']>(name: T): string;
    export function reverse<T extends WithArguments['name']>(name: T, args: Extract<WithArguments, {name: T}>['args']): string;
    export function reverse<T extends All['name']>(name: T, args?: Extract<WithArguments, {name: T}>['args']): string {
        let route = urls[name].route;

        if (args != null) {
            for (const token of Object.keys(args)) {
                route = route.replace(new RegExp('<(.+?:)' + token + '>'), (args as any)[token]);
            }
        }
        return route;
    }

import React from "react"
import createContext from "reactivated/dist/context";
import * as forms from "reactivated/dist/forms";
import * as generated from "reactivated/dist/generated";

// Note: this needs strict function types to behave correctly with excess properties etc.
export type Checker<P, U extends (React.FunctionComponent<P> | React.ComponentClass<P>)> = {};

export const {Context, Provider, getServerData} = createContext<_Types["Context"]>();

export const getTemplate = ({template_name}: {template_name: string}) => {
    // This require needs to be *inside* the function to avoid circular dependencies with esbuild.
    const { default: templates, filenames } = require('../../client/templates/**/*');
    const templatePath = "../../client/templates/" + template_name + ".tsx";
    const possibleTemplate: {default: React.ComponentType<any>} | null = templates.find((t: any, index: number) => filenames[index] === templatePath);

    if (possibleTemplate == null) {
        throw new Error("Template " + template_name + ".tsx not found");
    }
    return possibleTemplate.default;
}

export const CSRFToken = forms.createCSRFToken(Context);

export const {createRenderer, Iterator} = forms.bindWidgetType<_Types["globals"]["Widget"]>();
export type FieldHandler = forms.FieldHandler<_Types["globals"]["Widget"]>;
export type models = _Types["globals"]["models"];

export const {Form, FormSet, Widget, useForm, useFormSet, ManagementForm} = forms;


import HomepageIndexImplementation from "@client/templates/HomepageIndex"
export type HomepageIndexCheck = Checker<_Types["HomepageIndexProps"], typeof HomepageIndexImplementation>;

export namespace templates {
    export type HomepageIndex = _Types["HomepageIndexProps"];
}


import StockTrackerBarcodeSheetImplementation from "@client/templates/StockTrackerBarcodeSheet"
export type StockTrackerBarcodeSheetCheck = Checker<_Types["StockTrackerBarcodeSheetProps"], typeof StockTrackerBarcodeSheetImplementation>;

export namespace templates {
    export type StockTrackerBarcodeSheet = _Types["StockTrackerBarcodeSheetProps"];
}


import StockTrackerBarcodeSheetsHistoryImplementation from "@client/templates/StockTrackerBarcodeSheetsHistory"
export type StockTrackerBarcodeSheetsHistoryCheck = Checker<_Types["StockTrackerBarcodeSheetsHistoryProps"], typeof StockTrackerBarcodeSheetsHistoryImplementation>;

export namespace templates {
    export type StockTrackerBarcodeSheetsHistory = _Types["StockTrackerBarcodeSheetsHistoryProps"];
}


import StocktrackerStoreManagerNamesImplementation from "@client/templates/StocktrackerStoreManagerNames"
export type StocktrackerStoreManagerNamesCheck = Checker<_Types["StocktrackerStoreManagerNamesProps"], typeof StocktrackerStoreManagerNamesImplementation>;

export namespace templates {
    export type StocktrackerStoreManagerNames = _Types["StocktrackerStoreManagerNamesProps"];
}


import StockTrackerScannerImplementation from "@client/templates/StockTrackerScanner"
export type StockTrackerScannerCheck = Checker<_Types["StockTrackerScannerProps"], typeof StockTrackerScannerImplementation>;

export namespace templates {
    export type StockTrackerScanner = _Types["StockTrackerScannerProps"];
}


import StockTrackerScanHistoryImplementation from "@client/templates/StockTrackerScanHistory"
export type StockTrackerScanHistoryCheck = Checker<_Types["StockTrackerScanHistoryProps"], typeof StockTrackerScanHistoryImplementation>;

export namespace templates {
    export type StockTrackerScanHistory = _Types["StockTrackerScanHistoryProps"];
}


import ProductLocatorIndexImplementation from "@client/templates/ProductLocatorIndex"
export type ProductLocatorIndexCheck = Checker<_Types["ProductLocatorIndexProps"], typeof ProductLocatorIndexImplementation>;

export namespace templates {
    export type ProductLocatorIndex = _Types["ProductLocatorIndexProps"];
}


import ProductLocatorAddNewProductsImplementation from "@client/templates/ProductLocatorAddNewProducts"
export type ProductLocatorAddNewProductsCheck = Checker<_Types["ProductLocatorAddNewProductsProps"], typeof ProductLocatorAddNewProductsImplementation>;

export namespace templates {
    export type ProductLocatorAddNewProducts = _Types["ProductLocatorAddNewProductsProps"];
}


import ProductLocatorManagePlanogramsImplementation from "@client/templates/ProductLocatorManagePlanograms"
export type ProductLocatorManagePlanogramsCheck = Checker<_Types["ProductLocatorManagePlanogramsProps"], typeof ProductLocatorManagePlanogramsImplementation>;

export namespace templates {
    export type ProductLocatorManagePlanograms = _Types["ProductLocatorManagePlanogramsProps"];
}


import ProductLocatorScanAuditImplementation from "@client/templates/ProductLocatorScanAudit"
export type ProductLocatorScanAuditCheck = Checker<_Types["ProductLocatorScanAuditProps"], typeof ProductLocatorScanAuditImplementation>;

export namespace templates {
    export type ProductLocatorScanAudit = _Types["ProductLocatorScanAuditProps"];
}


import QtIndexImplementation from "@client/templates/QtIndex"
export type QtIndexCheck = Checker<_Types["QtIndexProps"], typeof QtIndexImplementation>;

export namespace templates {
    export type QtIndex = _Types["QtIndexProps"];
}


import QtAdminImplementation from "@client/templates/QtAdmin"
export type QtAdminCheck = Checker<_Types["QtAdminProps"], typeof QtAdminImplementation>;

export namespace templates {
    export type QtAdmin = _Types["QtAdminProps"];
}


import QtRepSessionDetailsImplementation from "@client/templates/QtRepSessionDetails"
export type QtRepSessionDetailsCheck = Checker<_Types["QtRepSessionDetailsProps"], typeof QtRepSessionDetailsImplementation>;

export namespace templates {
    export type QtRepSessionDetails = _Types["QtRepSessionDetailsProps"];
}


import QtScheduleViewImplementation from "@client/templates/QtScheduleView"
export type QtScheduleViewCheck = Checker<_Types["QtScheduleViewProps"], typeof QtScheduleViewImplementation>;

export namespace templates {
    export type QtScheduleView = _Types["QtScheduleViewProps"];
}


import QtTerritoryViewerImplementation from "@client/templates/QtTerritoryViewer"
export type QtTerritoryViewerCheck = Checker<_Types["QtTerritoryViewerProps"], typeof QtTerritoryViewerImplementation>;

export namespace templates {
    export type QtTerritoryViewer = _Types["QtTerritoryViewerProps"];
}


import QtUpdateScheduleImplementation from "@client/templates/QtUpdateSchedule"
export type QtUpdateScheduleCheck = Checker<_Types["QtUpdateScheduleProps"], typeof QtUpdateScheduleImplementation>;

export namespace templates {
    export type QtUpdateSchedule = _Types["QtUpdateScheduleProps"];
}


import QtAutofillLogsImplementation from "@client/templates/QtAutofillLogs"
export type QtAutofillLogsCheck = Checker<_Types["QtAutofillLogsProps"], typeof QtAutofillLogsImplementation>;

export namespace templates {
    export type QtAutofillLogs = _Types["QtAutofillLogsProps"];
}


export namespace interfaces {
    export type IProductLocatorProduct = _Types["IProductLocatorProductProps"];
}


export namespace interfaces {
    export type MatchingProducts = _Types["MatchingProductsProps"];
}


export namespace interfaces {
    export type IHomeLocationUpdate = _Types["IHomeLocationUpdateProps"];
}


export namespace interfaces {
    export type IScanAuditCreation = _Types["IScanAuditCreationProps"];
}


export namespace interfaces {
    export type IPlanogramsByStore = _Types["IPlanogramsByStoreProps"];
}


export namespace interfaces {
    export type IProductLocations = _Types["IProductLocationsProps"];
}


export namespace interfaces {
    export type ISuccess = _Types["ISuccessProps"];
}


export namespace interfaces {
    export type QtLoginSessionRefetch = _Types["QtLoginSessionRefetchProps"];
}


export namespace interfaces {
    export type QtViewRepDetail = _Types["QtViewRepDetailProps"];
}


export namespace interfaces {
    export type TPaginationData = _Types["TPaginationDataProps"];
}


        


        


        


        


        


        


        


        


        


        


        


        


        


        


        


        


        


        


        


        


        


        


        


        


        


        


        

